// This file is auto-generated by @hey-api/openapi-ts

import { client as _heyApiClient } from './client.gen'

import type {
  AttachmentsUpdateData,
  AttachmentsUpdateResponse,
  AttachmentsUpdateSignedUrlCreateData,
  AttachmentsUpdateSignedUrlCreateResponse,
  AttachmentsVersionDestroyData,
  AttachmentsVersionDestroyResponse,
  AttachmentsVersionRetrieveData,
  AttachmentsVersionRetrieveResponse,
  AttachmentsCreateSignedUrlCreateData,
  AttachmentsCreateSignedUrlCreateResponse,
  AttachmentsDestroyData,
  AttachmentsDestroyResponse,
  AttachmentsListData,
  AttachmentsListResponse,
  AttachmentsPartialUpdateData,
  AttachmentsPartialUpdateResponse,
  AttachmentsRetrieveData,
  AttachmentsRetrieveResponse,
  BranchesListListData,
  BranchesListListResponse,
  CallsCreateData,
  CallsCreateResponse,
  CallsDestroyData,
  CallsDestroyResponse,
  CallsListData,
  CallsListResponse,
  CallsPartialUpdateData,
  CallsPartialUpdateResponse,
  CallsRetrieveData,
  CallsRetrieveResponse,
  CallsSubscriptionNotificationCreateData,
  CallsSubscriptionNotificationCreateResponse,
  CallsTriggerSubscribeCreateData,
  CallsTriggerSubscribeCreateResponse,
  CallsUpdateData,
  CallsUpdateResponse,
  CitiesListData,
  CitiesListListData,
  CitiesListListResponse,
  CitiesListResponse,
  CitiesRetrieveData,
  CitiesRetrieveResponse,
  ClientsContactsListData,
  ClientsContactsListResponse,
  ClientsContactsRetrieveData,
  ClientsContactsRetrieveResponse,
  ClientsContractsListData,
  ClientsContractsListResponse,
  ClientsContractsRetrieveData,
  ClientsContractsRetrieveResponse,
  ClientsLeadsListData,
  ClientsLeadsListResponse,
  ClientsLeadsRetrieveData,
  ClientsLeadsRetrieveResponse,
  ClientsLogsListData,
  ClientsLogsListResponse,
  ClientsLogsRetrieveData,
  ClientsLogsRetrieveResponse,
  ClientsOpportunitiesListData,
  ClientsOpportunitiesListResponse,
  ClientsOpportunitiesCreateData,
  ClientsOpportunitiesCreateResponse,
  ClientsOpportunitiesDestroyData,
  ClientsOpportunitiesDestroyResponse,
  ClientsOpportunitiesRetrieveData,
  ClientsOpportunitiesRetrieveResponse,
  ClientsOpportunitiesPartialUpdateData,
  ClientsOpportunitiesPartialUpdateResponse,
  ClientsOpportunitiesUpdateData,
  ClientsOpportunitiesUpdateResponse,
  ClientsTasksListData,
  ClientsTasksListResponse,
  ClientsTasksCreateData,
  ClientsTasksCreateResponse,
  ClientsTasksDestroyData,
  ClientsTasksDestroyResponse,
  ClientsTasksRetrieveData,
  ClientsTasksRetrieveResponse,
  ClientsTasksPartialUpdateData,
  ClientsTasksPartialUpdateResponse,
  ClientsTasksUpdateData,
  ClientsTasksUpdateResponse,
  ClientsRetrieveData,
  ClientsRetrieveResponse,
  ClientsImportContractCreateData,
  ClientsImportContractCreateResponse,
  ClientsListData,
  ClientsListResponse,
  ClientStatusesListData,
  ClientStatusesListListData,
  ClientStatusesListListResponse,
  ClientStatusesListResponse,
  ClientStatusesRetrieveData,
  ClientStatusesRetrieveResponse,
  CompanySizesCreateData,
  CompanySizesCreateResponse,
  CompanySizesDestroyData,
  CompanySizesDestroyResponse,
  CompanySizesListData,
  CompanySizesListListData,
  CompanySizesListListResponse,
  CompanySizesListResponse,
  CompanySizesPartialUpdateData,
  CompanySizesPartialUpdateResponse,
  CompanySizesRetrieveData,
  CompanySizesRetrieveResponse,
  CompanySizesUpdateData,
  CompanySizesUpdateResponse,
  ConnectorsBulkAddContactsCreateData,
  ConnectorsBulkAddContactsCreateResponse,
  ConnectorsListListData,
  ConnectorsListListResponse,
  ConnectorsOptionsRetrieveData,
  ConnectorsOptionsRetrieveResponse,
  ContactsPartialUpdateData,
  ContactsPartialUpdateResponse,
  ContactsUpdateData,
  ContactsUpdateResponse,
  ContactsConnectionsRetrieveData,
  ContactsConnectionsRetrieveResponse,
  ContactsCreateData,
  ContactsCreateResponse,
  ContactsDestroyData,
  ContactsDestroyResponse,
  ContactsInitCallCreateData,
  ContactsInitCallCreateResponse,
  ContactsListData,
  ContactsListResponse,
  ContactsPhoneNumbersCreateData,
  ContactsPhoneNumbersCreateResponse,
  ContactsPhoneNumbersDestroyData,
  ContactsPhoneNumbersDestroyResponse,
  ContactsPhoneNumbersListData,
  ContactsPhoneNumbersListResponse,
  ContactsPhoneNumbersPartialUpdateData,
  ContactsPhoneNumbersPartialUpdateResponse,
  ContactsPhoneNumbersRetrieveData,
  ContactsPhoneNumbersRetrieveResponse,
  ContactsPhoneNumbersUpdateData,
  ContactsPhoneNumbersUpdateResponse,
  ContactsRetrieveData,
  ContactsRetrieveResponse,
  ContractsCreateData,
  ContractsCreateResponse,
  ContractsDestroyData,
  ContractsDestroyResponse,
  ContractsFetchSiAsigCreateData,
  ContractsFetchSiAsigCreateResponse,
  ContractsListData,
  ContractsListResponse,
  ContractsPartialUpdateData,
  ContractsPartialUpdateResponse,
  ContractsRetrieveData,
  ContractsRetrieveResponse,
  ContractsUpdateData,
  ContractsUpdateResponse,
  CountriesPartialUpdateData,
  CountriesPartialUpdateResponse,
  CountriesUpdateData,
  CountriesUpdateResponse,
  CountriesContinentsListData,
  CountriesContinentsListResponse,
  CountriesCreateData,
  CountriesCreateResponse,
  CountriesDestroyData,
  CountriesDestroyResponse,
  CountriesListData,
  CountriesListListData,
  CountriesListListResponse,
  CountriesListResponse,
  CountriesRetrieveData,
  CountriesRetrieveResponse,
  CurrenciesCreateData,
  CurrenciesCreateResponse,
  CurrenciesDestroyData,
  CurrenciesDestroyResponse,
  CurrenciesListData,
  CurrenciesListListData,
  CurrenciesListListResponse,
  CurrenciesListResponse,
  CurrenciesPartialUpdateData,
  CurrenciesPartialUpdateResponse,
  CurrenciesRetrieveData,
  CurrenciesRetrieveResponse,
  CurrenciesUpdateData,
  CurrenciesUpdateResponse,
  CustomFieldsCreateData,
  CustomFieldsCreateResponse,
  CustomFieldsDestroyData,
  CustomFieldsDestroyResponse,
  CustomFieldsListData,
  CustomFieldsListResponse,
  CustomFieldsPartialUpdateData,
  CustomFieldsPartialUpdateResponse,
  CustomFieldsRetrieveData,
  CustomFieldsRetrieveResponse,
  CustomFieldsUndeletePartialUpdateData,
  CustomFieldsUndeletePartialUpdateResponse,
  CustomFieldsUpdateData,
  CustomFieldsUpdateResponse,
  DashboardLeadsListData,
  DashboardLeadsListResponse,
  DashboardReportsChartListData,
  DashboardReportsChartListResponse,
  DashboardSalesReportListData,
  DashboardSalesReportListResponse,
  DashboardTasksRetrieveData,
  DashboardTasksRetrieveResponse,
  DashboardTopExpertsListData,
  DashboardTopExpertsListResponse,
  DocumentCategoriesCreateData,
  DocumentCategoriesCreateResponse,
  DocumentCategoriesDestroyData,
  DocumentCategoriesDestroyResponse,
  DocumentCategoriesListData,
  DocumentCategoriesListListData,
  DocumentCategoriesListListResponse,
  DocumentCategoriesListResponse,
  DocumentCategoriesPartialUpdateData,
  DocumentCategoriesPartialUpdateResponse,
  DocumentCategoriesRetrieveData,
  DocumentCategoriesRetrieveResponse,
  DocumentCategoriesUpdateData,
  DocumentCategoriesUpdateResponse,
  DocumentsPartialUpdateData,
  DocumentsPartialUpdateResponse,
  DocumentsUpdateData,
  DocumentsUpdateResponse,
  DocumentsBulkCreateCreateData,
  DocumentsBulkCreateCreateResponse,
  DocumentsCreateData,
  DocumentsCreateResponse,
  DocumentsDestroyData,
  DocumentsDestroyResponse,
  DocumentsListData,
  DocumentsListListData,
  DocumentsListListResponse,
  DocumentsListResponse,
  DocumentsRetrieveData,
  DocumentsRetrieveResponse,
  ExpensesCreateData,
  ExpensesCreateResponse,
  ExpensesListData,
  ExpensesListResponse,
  HealthRetrieveData,
  HealthRetrieveResponse,
  IndustriesCreateData,
  IndustriesCreateResponse,
  IndustriesSubIndustriesRetrieveData,
  IndustriesSubIndustriesRetrieveResponse,
  IndustriesSubIndustriesPartialUpdateData,
  IndustriesSubIndustriesPartialUpdateResponse,
  IndustriesSubIndustriesUpdateData,
  IndustriesSubIndustriesUpdateResponse,
  IndustriesSubIndustriesListListData,
  IndustriesSubIndustriesListListResponse,
  IndustriesDestroyData,
  IndustriesDestroyResponse,
  IndustriesListData,
  IndustriesRetrieveResponse,
  IndustriesPartialUpdateData,
  IndustriesPartialUpdateResponse,
  IndustriesUpdateData,
  IndustriesUpdateResponse,
  IndustriesListListData,
  IndustriesListListResponse,
  IndustriesListResponse,
  IndustriesRetrieveData,
  IndustriesSubIndustriesCreateData,
  IndustriesSubIndustriesCreateResponse,
  IndustriesSubIndustriesDestroyData,
  IndustriesSubIndustriesDestroyResponse,
  IndustriesSubIndustriesListData,
  IndustriesSubIndustriesListResponse,
  InformationCreateData,
  InformationCreateResponse,
  InformationDestroyData,
  InformationDestroyResponse,
  InformationListData,
  InformationListListData,
  InformationListListResponse,
  InformationListResponse,
  InformationPartialUpdateData,
  InformationPartialUpdateResponse,
  InformationRetrieveData,
  InformationRetrieveResponse,
  InformationUpdateData,
  InformationUpdateResponse,
  IntegrationsGmailPartialUpdateData,
  IntegrationsGmailPartialUpdateResponse,
  IntegrationsGmailUpdateData,
  IntegrationsGmailUpdateResponse,
  IntegrationsGmailCheckMailboxRetrieveData,
  IntegrationsGmailCheckMailboxRetrieveResponse,
  IntegrationsGmailAuthCallbackCreateData,
  IntegrationsGmailAuthCallbackCreateResponse,
  IntegrationsGmailAuthUrlRetrieveData,
  IntegrationsGmailAuthUrlRetrieveResponse,
  IntegrationsGmailCreateData,
  IntegrationsGmailCreateResponse,
  IntegrationsGmailDestroyData,
  IntegrationsGmailDestroyResponse,
  IntegrationsGmailListData,
  IntegrationsGmailListListData,
  IntegrationsGmailListListResponse,
  IntegrationsGmailListResponse,
  IntegrationsGmailLogoutMailboxCreateData,
  IntegrationsGmailLogoutMailboxCreateResponse,
  IntegrationsGmailRetrieveData,
  IntegrationsGmailRetrieveResponse,
  IntegrationsMessengerPartialUpdateData,
  IntegrationsMessengerPartialUpdateResponse,
  IntegrationsMessengerUpdateData,
  IntegrationsMessengerUpdateResponse,
  IntegrationsMessengerCheckMailboxRetrieveData,
  IntegrationsMessengerCheckMailboxRetrieveResponse,
  IntegrationsMessengerAuthCallbackCreateData,
  IntegrationsMessengerAuthCallbackCreateResponse,
  IntegrationsMessengerAuthUrlRetrieveData,
  IntegrationsMessengerAuthUrlRetrieveResponse,
  IntegrationsMessengerCreateData,
  IntegrationsMessengerCreateResponse,
  IntegrationsMessengerDestroyData,
  IntegrationsMessengerDestroyResponse,
  IntegrationsMessengerListData,
  IntegrationsMessengerListListData,
  IntegrationsMessengerListListResponse,
  IntegrationsMessengerListResponse,
  IntegrationsMessengerLogoutMailboxCreateData,
  IntegrationsMessengerLogoutMailboxCreateResponse,
  IntegrationsMessengerRetrieveData,
  IntegrationsMessengerRetrieveResponse,
  IntegrationsWhatsappConfigCreateData,
  IntegrationsWhatsappConfigCreateResponse,
  IntegrationsWhatsappConfigDestroyData,
  IntegrationsWhatsappConfigDestroyResponse,
  IntegrationsWhatsappConfigListData,
  IntegrationsWhatsappConfigListResponse,
  IntegrationsWhatsappConfigPartialUpdateData,
  IntegrationsWhatsappConfigPartialUpdateResponse,
  IntegrationsWhatsappConfigRetrieveData,
  IntegrationsWhatsappConfigRetrieveResponse,
  IntegrationsWhatsappConfigTestCreateData,
  IntegrationsWhatsappConfigTestCreateResponse,
  IntegrationsWhatsappConfigUpdateData,
  IntegrationsWhatsappConfigUpdateResponse,
  IntegrationsWhatsappMessagesListData,
  IntegrationsWhatsappMessagesListResponse,
  IntegrationsWhatsappMessagesRetrieveData,
  IntegrationsWhatsappMessagesRetrieveResponse,
  IntegrationsWhatsappMessagesRetryCreateData,
  IntegrationsWhatsappMessagesRetryCreateResponse,
  IntegrationsWhatsappMessagesSendCreateData,
  IntegrationsWhatsappMessagesSendCreateResponse,
  IntegrationsWhatsappMessageTemplatesListData,
  IntegrationsWhatsappMessageTemplatesListResponse,
  IntegrationsWhatsappMessageTemplatesSyncCreateData,
  IntegrationsWhatsappMessageTemplatesSyncCreateResponse,
  InternalCitiesListData,
  InternalCitiesListListData,
  InternalCitiesListListResponse,
  InternalCitiesListResponse,
  InternalCitiesRetrieveData,
  InternalCitiesRetrieveResponse,
  InternalCompanySizesCreateData,
  InternalCompanySizesCreateResponse,
  InternalCompanySizesDestroyData,
  InternalCompanySizesDestroyResponse,
  InternalCompanySizesListData,
  InternalCompanySizesListListData,
  InternalCompanySizesListListResponse,
  InternalCompanySizesListResponse,
  InternalCompanySizesPartialUpdateData,
  InternalCompanySizesPartialUpdateResponse,
  InternalCompanySizesRetrieveData,
  InternalCompanySizesRetrieveResponse,
  InternalCompanySizesUpdateData,
  InternalCompanySizesUpdateResponse,
  InternalContactsPartialUpdateData,
  InternalContactsPartialUpdateResponse,
  InternalContactsUpdateData,
  InternalContactsUpdateResponse,
  InternalContactsConnectionsRetrieveData,
  InternalContactsConnectionsRetrieveResponse,
  InternalContactsCreateData,
  InternalContactsCreateResponse,
  InternalContactsDestroyData,
  InternalContactsDestroyResponse,
  InternalContactsInitCallCreateData,
  InternalContactsInitCallCreateResponse,
  InternalContactsListData,
  InternalContactsListResponse,
  InternalContactsPhoneNumbersCreateData,
  InternalContactsPhoneNumbersCreateResponse,
  InternalContactsPhoneNumbersDestroyData,
  InternalContactsPhoneNumbersDestroyResponse,
  InternalContactsPhoneNumbersListData,
  InternalContactsPhoneNumbersListResponse,
  InternalContactsPhoneNumbersPartialUpdateData,
  InternalContactsPhoneNumbersPartialUpdateResponse,
  InternalContactsPhoneNumbersRetrieveData,
  InternalContactsPhoneNumbersRetrieveResponse,
  InternalContactsPhoneNumbersUpdateData,
  InternalContactsPhoneNumbersUpdateResponse,
  InternalContactsRetrieveData,
  InternalContactsRetrieveResponse,
  InternalCountriesPartialUpdateData,
  InternalCountriesPartialUpdateResponse,
  InternalCountriesUpdateData,
  InternalCountriesUpdateResponse,
  InternalCountriesContinentsListData,
  InternalCountriesContinentsListResponse,
  InternalCountriesCreateData,
  InternalCountriesCreateResponse,
  InternalCountriesDestroyData,
  InternalCountriesDestroyResponse,
  InternalCountriesListData,
  InternalCountriesListListData,
  InternalCountriesListListResponse,
  InternalCountriesListResponse,
  InternalCountriesRetrieveData,
  InternalCountriesRetrieveResponse,
  InternalCurrenciesCreateData,
  InternalCurrenciesCreateResponse,
  InternalCurrenciesDestroyData,
  InternalCurrenciesDestroyResponse,
  InternalCurrenciesListData,
  InternalCurrenciesListListData,
  InternalCurrenciesListListResponse,
  InternalCurrenciesListResponse,
  InternalCurrenciesPartialUpdateData,
  InternalCurrenciesPartialUpdateResponse,
  InternalCurrenciesRetrieveData,
  InternalCurrenciesRetrieveResponse,
  InternalCurrenciesUpdateData,
  InternalCurrenciesUpdateResponse,
  InternalIndustriesCreateData,
  InternalIndustriesCreateResponse,
  InternalIndustriesSubIndustriesRetrieveData,
  InternalIndustriesSubIndustriesRetrieveResponse,
  InternalIndustriesSubIndustriesPartialUpdateData,
  InternalIndustriesSubIndustriesPartialUpdateResponse,
  InternalIndustriesSubIndustriesUpdateData,
  InternalIndustriesSubIndustriesUpdateResponse,
  InternalIndustriesSubIndustriesListListData,
  InternalIndustriesSubIndustriesListListResponse,
  InternalIndustriesDestroyData,
  InternalIndustriesDestroyResponse,
  InternalIndustriesListData,
  InternalIndustriesRetrieveResponse,
  InternalIndustriesPartialUpdateData,
  InternalIndustriesPartialUpdateResponse,
  InternalIndustriesUpdateData,
  InternalIndustriesUpdateResponse,
  InternalIndustriesListListData,
  InternalIndustriesListListResponse,
  InternalIndustriesListResponse,
  InternalIndustriesRetrieveData,
  InternalIndustriesSubIndustriesCreateData,
  InternalIndustriesSubIndustriesCreateResponse,
  InternalIndustriesSubIndustriesDestroyData,
  InternalIndustriesSubIndustriesDestroyResponse,
  InternalIndustriesSubIndustriesListData,
  InternalIndustriesSubIndustriesListResponse,
  InternalLeadsCreateData,
  InternalLeadsCreateResponse,
  InternalLeadsStatusesRetrieveData,
  InternalLeadsStatusesRetrieveResponse,
  InternalLeadsStatusesPartialUpdateData,
  InternalLeadsStatusesPartialUpdateResponse,
  InternalLeadsStatusesUpdateData,
  InternalLeadsStatusesUpdateResponse,
  InternalLeadsStatusesListListData,
  InternalLeadsStatusesListListResponse,
  InternalLeadsTypesListData,
  InternalLeadsTypesListResponse,
  InternalLeadsTypesCreateData,
  InternalLeadsTypesCreateResponse,
  InternalLeadsTypesDestroyData,
  InternalLeadsTypesDestroyResponse,
  InternalLeadsTypesRetrieveData,
  InternalLeadsTypesRetrieveResponse,
  InternalLeadsTypesPartialUpdateData,
  InternalLeadsTypesPartialUpdateResponse,
  InternalLeadsTypesUpdateData,
  InternalLeadsTypesUpdateResponse,
  InternalLeadsTypesListListData,
  InternalLeadsTypesListListResponse,
  InternalLeadsDestroyData,
  InternalLeadsDestroyResponse,
  InternalLeadsListData,
  InternalLeadsRetrieveResponse,
  InternalLeadsPartialUpdateData,
  InternalLeadsPartialUpdateResponse,
  InternalLeadsUpdateData,
  InternalLeadsUpdateResponse,
  InternalLeadsListListData,
  InternalLeadsListListResponse,
  InternalLeadsListResponse,
  InternalLeadsRetrieveData,
  InternalLeadsStatusesCreateData,
  InternalLeadsStatusesCreateResponse,
  InternalLeadsStatusesDestroyData,
  InternalLeadsStatusesDestroyResponse,
  InternalLeadsStatusesListData,
  InternalLeadsStatusesListResponse,
  InternalLogsCreateData,
  InternalLogsCreateResponse,
  InternalLogsListData,
  InternalLogsListResponse,
  InternalLogsRetrieveData,
  InternalLogsRetrieveResponse,
  InternalOpportunitiesCreateData,
  InternalOpportunitiesCreateResponse,
  InternalOpportunitiesStatusesPartialUpdateData,
  InternalOpportunitiesStatusesPartialUpdateResponse,
  InternalOpportunitiesStatusesUpdateData,
  InternalOpportunitiesStatusesUpdateResponse,
  InternalOpportunitiesStatusesListListData,
  InternalOpportunitiesStatusesListListResponse,
  InternalOpportunitiesDestroyData,
  InternalOpportunitiesDestroyResponse,
  InternalOpportunitiesRetrieveData,
  InternalOpportunitiesRetrieveResponse,
  InternalOpportunitiesPartialUpdateData,
  InternalOpportunitiesPartialUpdateResponse,
  InternalOpportunitiesStatusesCreateData,
  InternalOpportunitiesStatusesCreateResponse,
  InternalOpportunitiesStatusesDestroyData,
  InternalOpportunitiesStatusesDestroyResponse,
  InternalOpportunitiesStatusesListData,
  InternalOpportunitiesStatusesListResponse,
  InternalOpportunitiesStatusesRetrieveData,
  InternalOpportunitiesStatusesRetrieveResponse,
  InternalOpportunitiesUpdateData,
  InternalOpportunitiesUpdateResponse,
  InternalProductsCreateData,
  InternalProductsCreateResponse,
  InternalProductsDestroyData,
  InternalProductsDestroyResponse,
  InternalProductsListData,
  InternalProductsListListData,
  InternalProductsListListResponse,
  InternalProductsListResponse,
  InternalProductsPartialUpdateData,
  InternalProductsPartialUpdateResponse,
  InternalProductsRetrieveData,
  InternalProductsRetrieveResponse,
  InternalProductsUpdateData,
  InternalProductsUpdateResponse,
  InternalReasonsCreateData,
  InternalReasonsCreateResponse,
  InternalReasonsDestroyData,
  InternalReasonsDestroyResponse,
  InternalReasonsListData,
  InternalReasonsListListData,
  InternalReasonsListListResponse,
  InternalReasonsListResponse,
  InternalReasonsPartialUpdateData,
  InternalReasonsPartialUpdateResponse,
  InternalReasonsRetrieveData,
  InternalReasonsRetrieveResponse,
  InternalReasonsUpdateData,
  InternalReasonsUpdateResponse,
  InternalRegionsListData,
  InternalRegionsListListData,
  InternalRegionsListListResponse,
  InternalRegionsListResponse,
  InternalRegionsRetrieveData,
  InternalRegionsRetrieveResponse,
  InternalSequencesPartialUpdateData,
  InternalSequencesPartialUpdateResponse,
  InternalSequencesUpdateData,
  InternalSequencesUpdateResponse,
  InternalSequencesAddLeadsCreateData,
  InternalSequencesAddLeadsCreateResponse,
  InternalSequencesCreateData,
  InternalSequencesCreateResponse,
  InternalSequencesDestroyData,
  InternalSequencesDestroyResponse,
  InternalSequencesDuplicateRetrieveData,
  InternalSequencesDuplicateRetrieveResponse,
  InternalSequencesListData,
  InternalSequencesListListData,
  InternalSequencesListListResponse,
  InternalSequencesListResponse,
  InternalSequencesRetrieveData,
  InternalSequencesRetrieveResponse,
  InternalSourcesCreateData,
  InternalSourcesCreateResponse,
  InternalSourcesDestroyData,
  InternalSourcesDestroyResponse,
  InternalSourcesListData,
  InternalSourcesListListData,
  InternalSourcesListListResponse,
  InternalSourcesListResponse,
  InternalSourcesPartialUpdateData,
  InternalSourcesPartialUpdateResponse,
  InternalSourcesRetrieveData,
  InternalSourcesRetrieveResponse,
  InternalSourcesUpdateData,
  InternalSourcesUpdateResponse,
  InternalTagsPartialUpdateData,
  InternalTagsPartialUpdateResponse,
  InternalTagsUpdateData,
  InternalTagsUpdateResponse,
  InternalTagsColorsRetrieveData,
  InternalTagsColorsRetrieveResponse,
  InternalTagsCreateData,
  InternalTagsCreateResponse,
  InternalTagsDestroyData,
  InternalTagsDestroyResponse,
  InternalTagsListData,
  InternalTagsListListData,
  InternalTagsListListResponse,
  InternalTagsListResponse,
  InternalTagsRetrieveData,
  InternalTagsRetrieveResponse,
  InternalTaskTypesPartialUpdateData,
  InternalTaskTypesPartialUpdateResponse,
  InternalTaskTypesUpdateData,
  InternalTaskTypesUpdateResponse,
  InternalTaskTypesAllRetrieveData,
  InternalTaskTypesAllRetrieveResponse,
  InternalTaskTypesCreateData,
  InternalTaskTypesCreateResponse,
  InternalTaskTypesDestroyData,
  InternalTaskTypesDestroyResponse,
  InternalTaskTypesListData,
  InternalTaskTypesListListData,
  InternalTaskTypesListListResponse,
  InternalTaskTypesListResponse,
  InternalTaskTypesRetrieveData,
  InternalTaskTypesRetrieveResponse,
  InvoicesPartialUpdateData,
  InvoicesPartialUpdateResponse,
  InvoicesUpdateData,
  InvoicesUpdateResponse,
  InvoicesChangeStatusPartialUpdateData,
  InvoicesChangeStatusPartialUpdateResponse,
  InvoicesDownloadRetrieveData,
  InvoicesDownloadRetrieveResponse,
  InvoicesEmailRetrieveData,
  InvoicesEmailRetrieveResponse,
  InvoicesResendEmailRetrieveData,
  InvoicesContractorsCreateData,
  InvoicesContractorsCreateResponse,
  InvoicesCreateData,
  InvoicesCreateResponse,
  InvoicesDestroyData,
  InvoicesDestroyResponse,
  InvoicesListData,
  InvoicesListResponse,
  InvoicesReportsExportCreateData,
  InvoicesReportsExportCreateResponse,
  InvoicesReportsRetrieveData,
  InvoicesReportsRetrieveResponse,
  InvoicesRetrieveData,
  InvoicesRetrieveResponse,
  InvoicesSettingsCreateData,
  InvoicesSettingsCreateResponse,
  InvoicesSettingsRetrieveData,
  InvoicesSettingsRetrieveResponse,
  LeadGenerationCampaignsListData,
  LeadGenerationCampaignsListResponse,
  LeadGenerationCampaignsPartialUpdateData,
  LeadGenerationCampaignsPartialUpdateResponse,
  LeadGenerationCampaignsRetrieveData,
  LeadGenerationCampaignsRetrieveResponse,
  LeadGenerationCampaignsRunsListData,
  LeadGenerationCampaignsRunsListResponse,
  LeadGenerationCampaignsTriggerCreateData,
  LeadGenerationCampaignsTriggerCreateResponse,
  LeadGenerationRunsRetrieveData,
  LeadGenerationRunsRetrieveResponse,
  LeadScorePartialUpdateData,
  LeadScorePartialUpdateResponse,
  LeadScoreUpdateData,
  LeadScoreUpdateResponse,
  LeadScoreFieldsRetrieveData,
  LeadScoreFieldsRetrieveResponse,
  LeadScoreListListData,
  LeadScoreListListResponse,
  LeadsListData,
  LeadsListResponse,
  LeadsCreateData,
  LeadsCreateResponse,
  LeadsImportListData,
  LeadsImportListResponse,
  LeadsImportCreateData,
  LeadsImportCreateResponse,
  LeadsImportDestroyData,
  LeadsImportDestroyResponse,
  LeadsImportRetrieveData,
  LeadsImportRetrieveResponse,
  LeadsImportPartialUpdateData,
  LeadsImportPartialUpdateResponse,
  LeadsImportUpdateData,
  LeadsImportUpdateResponse,
  LeadsImportColumnUniqueValuesRetrieveData,
  LeadsImportColumnUniqueValuesRetrieveResponse,
  LeadsImportPreviewRetrieveData,
  LeadsImportPreviewRetrieveResponse,
  LeadsImportHeadersRetrieveData,
  LeadsImportHeadersRetrieveResponse,
  LeadsImportUniqueFieldsRetrieveData,
  LeadsImportUniqueFieldsRetrieveResponse,
  LeadsStatusesListData,
  LeadsStatusesListResponse,
  LeadsStatusesCreateData,
  LeadsStatusesCreateResponse,
  LeadsStatusesDestroyData,
  LeadsStatusesDestroyResponse,
  LeadsStatusesRetrieveData,
  LeadsStatusesRetrieveResponse,
  LeadsStatusesPartialUpdateData,
  LeadsStatusesPartialUpdateResponse,
  LeadsStatusesUpdateData,
  LeadsStatusesUpdateResponse,
  LeadsStatusesListListData,
  LeadsStatusesListListResponse,
  LeadsTypesListData,
  LeadsTypesListResponse,
  LeadsTypesCreateData,
  LeadsTypesCreateResponse,
  LeadsTypesLeadsStatusesListData,
  LeadsTypesLeadsStatusesListResponse,
  LeadsTypesLeadsStatusesCreateData,
  LeadsTypesLeadsStatusesCreateResponse,
  LeadsTypesLeadsStatusesDestroyData,
  LeadsTypesLeadsStatusesDestroyResponse,
  LeadsTypesLeadsStatusesRetrieveData,
  LeadsTypesLeadsStatusesRetrieveResponse,
  LeadsTypesLeadsStatusesPartialUpdateData,
  LeadsTypesLeadsStatusesPartialUpdateResponse,
  LeadsTypesLeadsStatusesUpdateData,
  LeadsTypesLeadsStatusesUpdateResponse,
  LeadsTypesLeadsStatusesListListData,
  LeadsTypesLeadsStatusesListListResponse,
  LeadsTypesDestroyData,
  LeadsTypesDestroyResponse,
  LeadsTypesRetrieveData,
  LeadsTypesRetrieveResponse,
  LeadsTypesPartialUpdateData,
  LeadsTypesPartialUpdateResponse,
  LeadsTypesUpdateData,
  LeadsTypesUpdateResponse,
  LeadsTypesListListData,
  LeadsTypesListListResponse,
  LeadsContactsListData,
  LeadsContactsListResponse,
  LeadsContractsListData,
  LeadsContractsListResponse,
  LeadsDocumentsListData,
  LeadsDocumentsListResponse,
  LeadsLogsListData,
  LeadsLogsListResponse,
  LeadsOpportunitiesListData,
  LeadsOpportunitiesListResponse,
  LeadsSequencesListData,
  LeadsSequencesListResponse,
  LeadsSequencesCreateData,
  LeadsSequencesCreateResponse,
  LeadsSequencesDestroyData,
  LeadsSequencesDestroyResponse,
  LeadsSequencesRetrieveData,
  LeadsSequencesRetrieveResponse,
  LeadsSequencesPartialUpdateData,
  LeadsSequencesPartialUpdateResponse,
  LeadsSequencesUpdateData,
  LeadsSequencesUpdateResponse,
  LeadsTasksListData,
  LeadsTasksListResponse,
  LeadsDestroyData,
  LeadsDestroyResponse,
  LeadsRetrieveData,
  LeadsRetrieveResponse,
  LeadsPartialUpdateData,
  LeadsPartialUpdateResponse,
  LeadsUpdateData,
  LeadsUpdateResponse,
  LeadsConvertToClientCreateData,
  LeadsConvertToClientCreateResponse,
  LeadsInvoiceContactsRetrieveData,
  LeadsInvoiceContactsRetrieveResponse,
  LeadsInvoicesListData,
  LeadsInvoicesListResponse,
  LeadsMergePartialUpdateData,
  LeadsMergePartialUpdateResponse,
  LeadsSimilarRetrieveData,
  LeadsSimilarRetrieveResponse,
  LeadsUndeletePartialUpdateData,
  LeadsUndeletePartialUpdateResponse,
  LeadsBulkAssigneePartialUpdateData,
  LeadsBulkAssigneePartialUpdateResponse,
  LeadsBulkDeleteCreateData,
  LeadsBulkDeleteCreateResponse,
  LeadsBulkSetBranchPartialUpdateData,
  LeadsBulkSetBranchPartialUpdateResponse,
  LeadScoreCreateData,
  LeadScoreCreateResponse,
  LeadScoreDestroyData,
  LeadScoreDestroyResponse,
  LeadScoreListData,
  LeadScoreListResponse,
  LeadScoreRetrieveData,
  LeadScoreRetrieveResponse,
  LeadsDeletedListData,
  LeadsDeletedListResponse,
  LeadsExportRetrieveData,
  LeadsExportRetrieveResponse,
  LeadsListListData,
  LeadsListListResponse,
  LeadsPipelineListData,
  LeadsPipelineListResponse,
  LeadsSetTagPartialUpdateData,
  LeadsSetTagPartialUpdateResponse,
  LeadsViewedListData,
  LeadsViewedListResponse,
  ListViewsCreateData,
  ListViewsCreateResponse,
  ListViewsDestroyData,
  ListViewsDestroyResponse,
  ListViewsUpdateData,
  ListViewsUpdateResponse,
  ListViewsFieldsRetrieveData,
  ListViewsFieldsRetrieveResponse,
  ListViewsListData,
  ListViewsListResponse,
  ListViewsPartialUpdateData,
  ListViewsPartialUpdateResponse,
  ListViewsResultListData,
  ListViewsResultListResponse,
  ListViewsRetrieveData,
  ListViewsRetrieveResponse,
  LogsListData,
  LogsListResponse,
  LogsMeetingCreateData,
  LogsMeetingCreateResponse,
  LogsNoteCreateData,
  LogsNoteCreateResponse,
  LogsRetrieveData,
  LogsRetrieveResponse,
  MailboxesPartialUpdateData,
  MailboxesPartialUpdateResponse,
  MailboxesUpdateData,
  MailboxesUpdateResponse,
  MailboxesCheckMailboxRetrieveData,
  MailboxesCheckMailboxRetrieveResponse,
  MailboxesCreateData,
  MailboxesCreateResponse,
  MailboxesDestroyData,
  MailboxesDestroyResponse,
  MailboxesListData,
  MailboxesListListData,
  MailboxesListListResponse,
  MailboxesListResponse,
  MailboxesLoginRetrieveData,
  MailboxesLoginRetrieveResponse,
  MailboxesOauthLogoutCreateData,
  MailboxesOauthLogoutCreateResponse,
  MailboxesOauthLogoutLinkRetrieveData,
  MailboxesOauthLogoutLinkRetrieveResponse,
  MailboxesOauthOutlookCreateData,
  MailboxesOauthOutlookCreateResponse,
  MailboxesOutlookLinkRetrieveData,
  MailboxesOutlookLinkRetrieveResponse,
  MailboxesRetrieveData,
  MailboxesRetrieveResponse,
  MailboxesSendEmailCreateData,
  MailboxesTemplatesCreateData,
  MailboxesTemplatesCreateResponse,
  MailboxesTemplatesDestroyData,
  MailboxesTemplatesDestroyResponse,
  MailboxesTemplatesListData,
  MailboxesTemplatesListResponse,
  MailboxesTemplatesPartialUpdateData,
  MailboxesTemplatesPartialUpdateResponse,
  MailboxesTemplatesRetrieveData,
  MailboxesTemplatesRetrieveResponse,
  MailboxesTemplatesUpdateData,
  MailboxesTemplatesUpdateResponse,
  OpportunitiesStatusesDestroyData,
  OpportunitiesStatusesDestroyResponse,
  OpportunitiesStatusesRetrieveData,
  OpportunitiesStatusesRetrieveResponse,
  OpportunitiesStatusesPartialUpdateData,
  OpportunitiesStatusesPartialUpdateResponse,
  OpportunitiesStatusesUpdateData,
  OpportunitiesStatusesUpdateResponse,
  OpportunitiesStatusesListListData,
  OpportunitiesStatusesListListResponse,
  OpportunitiesContactsListData,
  OpportunitiesContactsListResponse,
  OpportunitiesContractsListData,
  OpportunitiesContractsListResponse,
  OpportunitiesDocumentsListData,
  OpportunitiesDocumentsListResponse,
  OpportunitiesLogsListData,
  OpportunitiesLogsListResponse,
  OpportunitiesTasksListData,
  OpportunitiesTasksListResponse,
  OpportunitiesDestroyData,
  OpportunitiesDestroyResponse,
  OpportunitiesRetrieveData,
  OpportunitiesRetrieveResponse,
  OpportunitiesPartialUpdateData,
  OpportunitiesPartialUpdateResponse,
  OpportunitiesUpdateData,
  OpportunitiesUpdateResponse,
  OpportunitiesConvertToClientCreateData,
  OpportunitiesConvertToClientCreateResponse,
  OpportunitiesCreateData,
  OpportunitiesCreateResponse,
  OpportunitiesDuplicateCreateData,
  OpportunitiesDuplicateCreateResponse,
  OpportunitiesListData,
  OpportunitiesListResponse,
  OpportunitiesMergePartialUpdateData,
  OpportunitiesMergePartialUpdateResponse,
  OpportunitiesPipelineListData,
  OpportunitiesPipelineListResponse,
  OpportunitiesPipelinesCreateData,
  OpportunitiesPipelinesCreateResponse,
  OpportunitiesPipelinesStatusesCreateData,
  OpportunitiesPipelinesStatusesCreateResponse,
  OpportunitiesPipelinesStatusesDestroyData,
  OpportunitiesPipelinesStatusesDestroyResponse,
  OpportunitiesPipelinesStatusesRetrieveData,
  OpportunitiesPipelinesStatusesRetrieveResponse,
  OpportunitiesPipelinesStatusesPartialUpdateData,
  OpportunitiesPipelinesStatusesPartialUpdateResponse,
  OpportunitiesPipelinesStatusesUpdateData,
  OpportunitiesPipelinesStatusesUpdateResponse,
  OpportunitiesPipelinesStatusesListListData,
  OpportunitiesPipelinesStatusesListListResponse,
  OpportunitiesPipelinesDestroyData,
  OpportunitiesPipelinesDestroyResponse,
  OpportunitiesPipelinesListData,
  OpportunitiesPipelinesRetrieveResponse,
  OpportunitiesPipelinesPartialUpdateData,
  OpportunitiesPipelinesPartialUpdateResponse,
  OpportunitiesPipelinesUpdateData,
  OpportunitiesPipelinesUpdateResponse,
  OpportunitiesPipelinesListListData,
  OpportunitiesPipelinesListListResponse,
  OpportunitiesPipelinesListResponse,
  OpportunitiesPipelinesRetrieveData,
  OpportunitiesPipelinesStatusesListData,
  OpportunitiesPipelinesStatusesListResponse,
  OpportunitiesProductsDestroyData,
  OpportunitiesProductsDestroyResponse,
  OpportunitiesProductsRetrieveData,
  OpportunitiesProductsRetrieveResponse,
  OpportunitiesProductsPartialUpdateData,
  OpportunitiesProductsPartialUpdateResponse,
  OpportunitiesProductsUpdateData,
  OpportunitiesProductsUpdateResponse,
  OpportunitiesProductsBulkCreateCreateData,
  OpportunitiesProductsBulkCreateCreateResponse,
  OpportunitiesProductsBulkUpdatePartialUpdateData,
  OpportunitiesProductsBulkUpdatePartialUpdateResponse,
  OpportunitiesProductsCreateData,
  OpportunitiesProductsCreateResponse,
  OpportunitiesProductsListData,
  OpportunitiesProductsListResponse,
  OpportunitiesStatusesCreateData,
  OpportunitiesStatusesCreateResponse,
  OpportunitiesStatusesListData,
  OpportunitiesStatusesListResponse,
  PresetTasksCreateData,
  PresetTasksCreateResponse,
  PresetTasksDestroyData,
  PresetTasksDestroyResponse,
  PresetTasksListData,
  PresetTasksListResponse,
  PresetTasksPartialUpdateData,
  PresetTasksPartialUpdateResponse,
  PresetTasksRetrieveData,
  PresetTasksRetrieveResponse,
  PresetTasksUpdateData,
  PresetTasksUpdateResponse,
  ProductsPartialUpdateData,
  ProductsPartialUpdateResponse,
  ProductsUpdateData,
  ProductsUpdateResponse,
  ProductsCategoriesListData,
  ProductsCategoriesListResponse,
  ProductsCategoriesCreateData,
  ProductsCategoriesCreateResponse,
  ProductsCategoriesDestroyData,
  ProductsCategoriesDestroyResponse,
  ProductsCategoriesRetrieveData,
  ProductsCategoriesRetrieveResponse,
  ProductsCategoriesPartialUpdateData,
  ProductsCategoriesPartialUpdateResponse,
  ProductsCategoriesUpdateData,
  ProductsCategoriesUpdateResponse,
  ProductsCategoriesListListData,
  ProductsCategoriesListListResponse,
  ProductsCreateData,
  ProductsCreateResponse,
  ProductsDestroyData,
  ProductsDestroyResponse,
  ProductsListData,
  ProductsListListData,
  ProductsListListResponse,
  ProductsListResponse,
  ProductsRetrieveData,
  ProductsRetrieveResponse,
  ProductsUnitsOfMeasureCreateData,
  ProductsUnitsOfMeasureCreateResponse,
  ProductsUnitsOfMeasureDestroyData,
  ProductsUnitsOfMeasureDestroyResponse,
  ProductsUnitsOfMeasureListData,
  ProductsUnitsOfMeasureListListData,
  ProductsUnitsOfMeasureListListResponse,
  ProductsUnitsOfMeasureListResponse,
  ProductsUnitsOfMeasurePartialUpdateData,
  ProductsUnitsOfMeasurePartialUpdateResponse,
  ProductsUnitsOfMeasureRetrieveData,
  ProductsUnitsOfMeasureRetrieveResponse,
  ProductsUnitsOfMeasureUpdateData,
  ProductsUnitsOfMeasureUpdateResponse,
  ReasonsCreateData,
  ReasonsCreateResponse,
  ReasonsDestroyData,
  ReasonsDestroyResponse,
  ReasonsListData,
  ReasonsListListData,
  ReasonsListListResponse,
  ReasonsListResponse,
  ReasonsPartialUpdateData,
  ReasonsPartialUpdateResponse,
  ReasonsRetrieveData,
  ReasonsRetrieveResponse,
  ReasonsUpdateData,
  ReasonsUpdateResponse,
  RegionsListData,
  RegionsListListData,
  RegionsListListResponse,
  RegionsListResponse,
  RegionsRetrieveData,
  RegionsRetrieveResponse,
  ReportsPartialUpdateData,
  ReportsPartialUpdateResponse,
  ReportsUpdateData,
  ReportsUpdateResponse,
  ReportsChartRetrieveData,
  ReportsChartRetrieveResponse,
  ReportsDuplicateCreateData,
  ReportsDuplicateCreateResponse,
  ReportsModelFieldsRetrieveData,
  ReportsModelFieldsRetrieveResponse,
  ReportsTableRetrieveData,
  ReportsTableRetrieveResponse,
  ReportsAggTypesRetrieveData,
  ReportsAggTypesRetrieveResponse,
  ReportsCallsReportsListData,
  ReportsCallsReportsListResponse,
  ReportsCountryWeightDiagramRetrieveData,
  ReportsCountryWeightDiagramRetrieveResponse,
  ReportsCreateData,
  ReportsCreateResponse,
  ReportsDemoChartListData,
  ReportsDemoChartListResponse,
  ReportsDestroyData,
  ReportsDestroyResponse,
  ReportsExportsListData,
  ReportsExportsListResponse,
  ReportsExportsRetrieveData,
  ReportsExportsRetrieveResponse,
  ReportsLeadChartListData,
  ReportsLeadChartListResponse,
  ReportsListData,
  ReportsListResponse,
  ReportsOfflineReportsListData,
  ReportsOfflineReportsListResponse,
  ReportsOnlineReportsListData,
  ReportsOnlineReportsListResponse,
  ReportsPhoneCallsChartListData,
  ReportsPhoneCallsChartListResponse,
  ReportsPreviewChartCreateData,
  ReportsPreviewChartCreateResponse,
  ReportsPreviewTableCreateData,
  ReportsPreviewTableCreateResponse,
  ReportsReasonWeightDiagramRetrieveData,
  ReportsReasonWeightDiagramRetrieveResponse,
  ReportsRetrieveData,
  ReportsRetrieveResponse,
  ReportsSalesFunnelListData,
  ReportsSalesFunnelListResponse,
  ReportsScoreWeightDiagramRetrieveData,
  ReportsScoreWeightDiagramRetrieveResponse,
  ReportsSourcePageWeightDiagramRetrieveData,
  ReportsSourcePageWeightDiagramRetrieveResponse,
  ReportsSourceWebsiteWeightDiagramRetrieveData,
  ReportsSourceWebsiteWeightDiagramRetrieveResponse,
  ReportsSourceWeightDiagramRetrieveData,
  ReportsSourceWeightDiagramRetrieveResponse,
  ReportsStatusWeightDiagramRetrieveData,
  ReportsStatusWeightDiagramRetrieveResponse,
  ReportsTopProductsCategoryDistributionExportCreateData,
  ReportsTopProductsCategoryDistributionExportCreateResponse,
  ReportsTopProductsCategoryDistributionRetrieveData,
  ReportsTopProductsCategoryDistributionRetrieveResponse,
  ReportsTopProductsExportCreateData,
  ReportsTopProductsExportCreateResponse,
  ReportsTopProductsRetrieveData,
  ReportsTopProductsRetrieveResponse,
  ReportsTypesRetrieveData,
  ReportsTypesRetrieveResponse,
  SchemaRetrieveData,
  SchemaRetrieveResponse,
  SearchDynamicExportRetrieveData,
  SearchDynamicExportRetrieveResponse,
  SearchDynamicListData,
  SearchDynamicListResponse,
  SearchDynamicModelFieldsRetrieveData,
  SearchDynamicModelFieldsRetrieveResponse,
  SearchDynamicModelsRetrieveData,
  SearchDynamicModelsRetrieveResponse,
  SearchListData,
  SearchListResponse,
  SeniorPositionsCreateData,
  SeniorPositionsCreateResponse,
  SeniorPositionsDestroyData,
  SeniorPositionsDestroyResponse,
  SeniorPositionsJobPositionsListData,
  SeniorPositionsJobPositionsListResponse,
  SeniorPositionsJobPositionsCreateData,
  SeniorPositionsJobPositionsCreateResponse,
  SeniorPositionsJobPositionsDestroyData,
  SeniorPositionsJobPositionsDestroyResponse,
  SeniorPositionsJobPositionsRetrieveData,
  SeniorPositionsJobPositionsRetrieveResponse,
  SeniorPositionsJobPositionsPartialUpdateData,
  SeniorPositionsJobPositionsPartialUpdateResponse,
  SeniorPositionsJobPositionsUpdateData,
  SeniorPositionsJobPositionsUpdateResponse,
  SeniorPositionsJobPositionsListListData,
  SeniorPositionsJobPositionsListListResponse,
  SeniorPositionsListData,
  SeniorPositionsListListData,
  SeniorPositionsListListResponse,
  SeniorPositionsListResponse,
  SeniorPositionsPartialUpdateData,
  SeniorPositionsPartialUpdateResponse,
  SeniorPositionsRetrieveData,
  SeniorPositionsRetrieveResponse,
  SeniorPositionsUpdateData,
  SeniorPositionsUpdateResponse,
  SequencesPartialUpdateData,
  SequencesPartialUpdateResponse,
  SequencesUpdateData,
  SequencesUpdateResponse,
  SequencesAddLeadsCreateData,
  SequencesAddLeadsCreateResponse,
  SequencesCreateData,
  SequencesCreateResponse,
  SequencesDestroyData,
  SequencesDestroyResponse,
  SequencesDuplicateRetrieveData,
  SequencesDuplicateRetrieveResponse,
  SequencesLeadsListData,
  SequencesLeadsListResponse,
  SequencesListData,
  SequencesStepsDestroyResponse,
  SequencesStepsRetrieveData,
  SequencesStepsRetrieveResponse,
  SequencesStepsPartialUpdateData,
  SequencesStepsPartialUpdateResponse,
  SequencesStepsUpdateData,
  SequencesStepsUpdateResponse,
  SequencesStepsListListData,
  SequencesStepsListListResponse,
  SequencesListListData,
  SequencesListListResponse,
  SequencesListResponse,
  SequencesRetrieveData,
  SequencesRetrieveResponse,
  SequencesStepsCreateData,
  SequencesStepsCreateResponse,
  SequencesStepsDestroyData,
  SequencesStepsListData,
  SequencesStepsListResponse,
  SettingsCreateData,
  SettingsCreateResponse,
  SettingsRetrieveData,
  SettingsRetrieveResponse,
  SourcesCreateData,
  SourcesCreateResponse,
  SourcesDestroyData,
  SourcesDestroyResponse,
  SourcesListData,
  SourcesListListData,
  SourcesListListResponse,
  SourcesListResponse,
  SourcesPartialUpdateData,
  SourcesPartialUpdateResponse,
  SourcesRetrieveData,
  SourcesRetrieveResponse,
  SourcesUpdateData,
  SourcesUpdateResponse,
  TagsPartialUpdateData,
  TagsPartialUpdateResponse,
  TagsUpdateData,
  TagsUpdateResponse,
  TagsColorsRetrieveData,
  TagsColorsRetrieveResponse,
  TagsCreateData,
  TagsCreateResponse,
  TagsDestroyData,
  TagsDestroyResponse,
  TagsListData,
  TagsListListData,
  TagsListListResponse,
  TagsListResponse,
  TagsRetrieveData,
  TagsRetrieveResponse,
  TaskStatusesPartialUpdateData,
  TaskStatusesPartialUpdateResponse,
  TaskStatusesUpdateData,
  TaskStatusesUpdateResponse,
  TaskStatusesListListData,
  TaskStatusesListListResponse,
  TaskTypesListData,
  TaskTypesListResponse,
  TaskTypesCreateData,
  TaskTypesCreateResponse,
  TaskTypesDestroyData,
  TaskTypesDestroyResponse,
  TaskTypesRetrieveData,
  TaskTypesRetrieveResponse,
  TaskTypesPartialUpdateData,
  TaskTypesPartialUpdateResponse,
  TaskTypesUpdateData,
  TaskTypesUpdateResponse,
  TaskTypesAllRetrieveData,
  TaskTypesAllRetrieveResponse,
  TaskTypesGenericListData,
  TaskTypesGenericListResponse,
  TaskTypesListListData,
  TaskTypesListListResponse,
  TaskTypesSystemListData,
  TaskTypesSystemListResponse,
  TasksListData,
  TasksListResponse,
  TasksCreateData,
  TasksCreateResponse,
  TasksDestroyData,
  TasksDestroyResponse,
  TasksRetrieveData,
  TasksRetrieveResponse,
  TasksPartialUpdateData,
  TasksPartialUpdateResponse,
  TasksUpdateData,
  TasksUpdateResponse,
  TasksCompleteCreateData,
  TasksCompleteCreateResponse,
  TasksKanbanListData,
  TasksKanbanListResponse,
  TaskStatusesCreateData,
  TaskStatusesCreateResponse,
  TaskStatusesDestroyData,
  TaskStatusesDestroyResponse,
  TaskStatusesListData,
  TaskStatusesListResponse,
  TaskStatusesRetrieveData,
  TaskStatusesRetrieveResponse,
  UsersAllListData,
  UsersAllListResponse,
  UsersAllowedModulesRetrieveData,
  UsersAllowedModulesRetrieveResponse,
  UsersListData,
  UsersListListData,
  UsersListListResponse,
  UsersListResponse,
  UsersPartialUpdateData,
  UsersPartialUpdateResponse,
  UsersProfileRetrieveData,
  UsersProfileRetrieveResponse,
  UsersUpdateData,
  UsersUpdateResponse,
  VoipConfigurationCreateData,
  VoipConfigurationCreateResponse,
  VoipConfigurationDestroyData,
  VoipConfigurationDestroyResponse,
  VoipConfigurationListData,
  VoipConfigurationListResponse,
  VoipConfigurationPartialUpdateData,
  VoipConfigurationPartialUpdateResponse,
  VoipConfigurationRetrieveData,
  VoipConfigurationRetrieveResponse,
  VoipConfigurationStatusRetrieveData,
  VoipConfigurationStatusRetrieveResponse,
  VoipConfigurationUpdateData,
  VoipConfigurationUpdateResponse,
  WebhookLeadCreateData,
  WebhookLeadCreateResponse,
  WebhookMinioCreateData,
  WebhookMinioCreateResponse,
  WebhookTaskCreateData,
  WebhookTaskCreateResponse,
  WebhookVoipCreateData,
  WebhookWhatsappCreateData,
  WebhookWhatsappRetrieveData,
  WidgetsRetrieveData,
  WidgetsRetrieveResponse
} from './types.gen'
import type {
  Client,
  Options as ClientOptions,
  TDataShape
} from '@hey-api/client-axios'

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean
> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

export const attachmentsList = <ThrowOnError extends boolean = false>(
  options?: Options<AttachmentsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    AttachmentsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/attachments',
    ...options
  })
}

export const attachmentsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<AttachmentsDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    AttachmentsDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/attachments/{id}',
    ...options
  })
}

export const attachmentsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<AttachmentsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    AttachmentsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/attachments/{id}',
    ...options
  })
}

export const attachmentsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<AttachmentsPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    AttachmentsPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/attachments/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const attachmentsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<AttachmentsUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    AttachmentsUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/attachments/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const attachmentsUpdateSignedUrlCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AttachmentsUpdateSignedUrlCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    AttachmentsUpdateSignedUrlCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/attachments/{id}/update-signed-url',
    ...options
  })
}

export const attachmentsVersionDestroy = <ThrowOnError extends boolean = false>(
  options: Options<AttachmentsVersionDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    AttachmentsVersionDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/attachments/{id}/version/{version_id}',
    ...options
  })
}

export const attachmentsVersionRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<AttachmentsVersionRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    AttachmentsVersionRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/attachments/{id}/version/{version_id}',
    ...options
  })
}

export const attachmentsCreateSignedUrlCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<AttachmentsCreateSignedUrlCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    AttachmentsCreateSignedUrlCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/attachments/create-signed-url',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const branchesListList = <ThrowOnError extends boolean = false>(
  options?: Options<BranchesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    BranchesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/branches/list',
    ...options
  })
}

export const callsList = <ThrowOnError extends boolean = false>(
  options?: Options<CallsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    CallsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/calls',
    ...options
  })
}

export const callsCreate = <ThrowOnError extends boolean = false>(
  options: Options<CallsCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CallsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/calls',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const callsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<CallsDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    CallsDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/calls/{id}',
    ...options
  })
}

export const callsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<CallsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    CallsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/calls/{id}',
    ...options
  })
}

export const callsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CallsPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    CallsPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/calls/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const callsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CallsUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    CallsUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/calls/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const callsSubscriptionNotificationCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<CallsSubscriptionNotificationCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CallsSubscriptionNotificationCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'text',
    url: '/calls/subscription-notification',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const callsTriggerSubscribeCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<CallsTriggerSubscribeCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CallsTriggerSubscribeCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/calls/trigger-subscribe',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const citiesList = <ThrowOnError extends boolean = false>(
  options?: Options<CitiesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    CitiesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/cities',
    ...options
  })
}

export const citiesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<CitiesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    CitiesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/cities/{id}',
    ...options
  })
}

export const citiesListList = <ThrowOnError extends boolean = false>(
  options?: Options<CitiesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    CitiesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/cities/list',
    ...options
  })
}

export const clientStatusesList = <ThrowOnError extends boolean = false>(
  options?: Options<ClientStatusesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ClientStatusesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/client-statuses',
    ...options
  })
}

export const clientStatusesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ClientStatusesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ClientStatusesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/client-statuses/{id}',
    ...options
  })
}

export const clientStatusesListList = <ThrowOnError extends boolean = false>(
  options?: Options<ClientStatusesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ClientStatusesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/client-statuses/list',
    ...options
  })
}

export const clientsList = <ThrowOnError extends boolean = false>(
  options?: Options<ClientsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ClientsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/clients',
    ...options
  })
}

export const clientsContactsList = <ThrowOnError extends boolean = false>(
  options: Options<ClientsContactsListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ClientsContactsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/clients/{client_id}/contacts',
    ...options
  })
}

export const clientsContactsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ClientsContactsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ClientsContactsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/clients/{client_id}/contacts/{id}',
    ...options
  })
}

export const clientsContractsList = <ThrowOnError extends boolean = false>(
  options: Options<ClientsContractsListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ClientsContractsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/clients/{client_id}/contracts',
    ...options
  })
}

export const clientsContractsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ClientsContractsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ClientsContractsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/clients/{client_id}/contracts/{id}',
    ...options
  })
}

export const clientsLeadsList = <ThrowOnError extends boolean = false>(
  options: Options<ClientsLeadsListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ClientsLeadsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/clients/{client_id}/leads',
    ...options
  })
}

export const clientsLeadsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ClientsLeadsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ClientsLeadsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/clients/{client_id}/leads/{id}',
    ...options
  })
}

export const clientsLogsList = <ThrowOnError extends boolean = false>(
  options: Options<ClientsLogsListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ClientsLogsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/clients/{client_id}/logs',
    ...options
  })
}

export const clientsLogsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ClientsLogsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ClientsLogsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/clients/{client_id}/logs/{id}',
    ...options
  })
}

export const clientsOpportunitiesList = <ThrowOnError extends boolean = false>(
  options: Options<ClientsOpportunitiesListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ClientsOpportunitiesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/clients/{client_id}/opportunities',
    ...options
  })
}

export const clientsOpportunitiesCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ClientsOpportunitiesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ClientsOpportunitiesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/clients/{client_id}/opportunities',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const clientsOpportunitiesDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<ClientsOpportunitiesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    ClientsOpportunitiesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/clients/{client_id}/opportunities/{id}',
    ...options
  })
}

export const clientsOpportunitiesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ClientsOpportunitiesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ClientsOpportunitiesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/clients/{client_id}/opportunities/{id}',
    ...options
  })
}

export const clientsOpportunitiesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ClientsOpportunitiesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    ClientsOpportunitiesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/clients/{client_id}/opportunities/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const clientsOpportunitiesUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ClientsOpportunitiesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    ClientsOpportunitiesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/clients/{client_id}/opportunities/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const clientsTasksList = <ThrowOnError extends boolean = false>(
  options: Options<ClientsTasksListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ClientsTasksListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/clients/{client_id}/tasks',
    ...options
  })
}

export const clientsTasksCreate = <ThrowOnError extends boolean = false>(
  options: Options<ClientsTasksCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ClientsTasksCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/clients/{client_id}/tasks',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const clientsTasksDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ClientsTasksDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    ClientsTasksDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/clients/{client_id}/tasks/{id}',
    ...options
  })
}

export const clientsTasksRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ClientsTasksRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ClientsTasksRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/clients/{client_id}/tasks/{id}',
    ...options
  })
}

export const clientsTasksPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ClientsTasksPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    ClientsTasksPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/clients/{client_id}/tasks/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const clientsTasksUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ClientsTasksUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    ClientsTasksUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/clients/{client_id}/tasks/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const clientsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ClientsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ClientsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/clients/{id}',
    ...options
  })
}

export const clientsImportContractCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ClientsImportContractCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ClientsImportContractCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/clients/{id}/import-contract',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const companySizesList = <ThrowOnError extends boolean = false>(
  options?: Options<CompanySizesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    CompanySizesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/company-sizes',
    ...options
  })
}

export const companySizesCreate = <ThrowOnError extends boolean = false>(
  options: Options<CompanySizesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CompanySizesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/company-sizes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const companySizesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<CompanySizesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    CompanySizesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/company-sizes/{id}',
    ...options
  })
}

export const companySizesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<CompanySizesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    CompanySizesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/company-sizes/{id}',
    ...options
  })
}

export const companySizesPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CompanySizesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    CompanySizesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/company-sizes/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const companySizesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CompanySizesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    CompanySizesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/company-sizes/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const companySizesListList = <ThrowOnError extends boolean = false>(
  options?: Options<CompanySizesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    CompanySizesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/company-sizes/list',
    ...options
  })
}

export const connectorsBulkAddContactsCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ConnectorsBulkAddContactsCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ConnectorsBulkAddContactsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/connectors/bulk-add-contacts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const connectorsListList = <ThrowOnError extends boolean = false>(
  options?: Options<ConnectorsListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ConnectorsListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/connectors/list',
    ...options
  })
}

export const connectorsOptionsRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<ConnectorsOptionsRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ConnectorsOptionsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/connectors/options',
    ...options
  })
}

export const contactsList = <ThrowOnError extends boolean = false>(
  options?: Options<ContactsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ContactsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/contacts',
    ...options
  })
}

export const contactsCreate = <ThrowOnError extends boolean = false>(
  options?: Options<ContactsCreateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    ContactsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/contacts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const contactsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ContactsDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    ContactsDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/contacts/{id}',
    ...options
  })
}

export const contactsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ContactsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ContactsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/contacts/{id}',
    ...options
  })
}

export const contactsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ContactsPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    ContactsPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/contacts/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const contactsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ContactsUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    ContactsUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/contacts/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

/**
 * Get contact connection graph
 * Returns graph nodes representing all contact connections such as leads and opportunities.
 */
export const contactsConnectionsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ContactsConnectionsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ContactsConnectionsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/contacts/{id}/connections',
    ...options
  })
}

export const contactsInitCallCreate = <ThrowOnError extends boolean = false>(
  options: Options<ContactsInitCallCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ContactsInitCallCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/contacts/{id}/init-call',
    ...options
  })
}

export const contactsPhoneNumbersList = <ThrowOnError extends boolean = false>(
  options?: Options<ContactsPhoneNumbersListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ContactsPhoneNumbersListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/contacts/phone-numbers',
    ...options
  })
}

export const contactsPhoneNumbersCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ContactsPhoneNumbersCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ContactsPhoneNumbersCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/contacts/phone-numbers',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const contactsPhoneNumbersDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<ContactsPhoneNumbersDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    ContactsPhoneNumbersDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/contacts/phone-numbers/{id}',
    ...options
  })
}

export const contactsPhoneNumbersRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ContactsPhoneNumbersRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ContactsPhoneNumbersRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/contacts/phone-numbers/{id}',
    ...options
  })
}

export const contactsPhoneNumbersPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ContactsPhoneNumbersPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    ContactsPhoneNumbersPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/contacts/phone-numbers/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const contactsPhoneNumbersUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ContactsPhoneNumbersUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    ContactsPhoneNumbersUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/contacts/phone-numbers/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const contractsList = <ThrowOnError extends boolean = false>(
  options?: Options<ContractsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ContractsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/contracts',
    ...options
  })
}

export const contractsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ContractsCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ContractsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/contracts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const contractsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ContractsDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    ContractsDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/contracts/{id}',
    ...options
  })
}

export const contractsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ContractsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ContractsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/contracts/{id}',
    ...options
  })
}

export const contractsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ContractsPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    ContractsPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/contracts/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const contractsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ContractsUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    ContractsUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/contracts/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const contractsFetchSiAsigCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ContractsFetchSiAsigCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ContractsFetchSiAsigCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/contracts/{id}/fetch-si-asig',
    ...options
  })
}

export const countriesList = <ThrowOnError extends boolean = false>(
  options?: Options<CountriesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    CountriesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/countries',
    ...options
  })
}

export const countriesCreate = <ThrowOnError extends boolean = false>(
  options: Options<CountriesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CountriesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/countries',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const countriesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<CountriesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    CountriesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/countries/{id}',
    ...options
  })
}

export const countriesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<CountriesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    CountriesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/countries/{id}',
    ...options
  })
}

export const countriesPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CountriesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    CountriesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/countries/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const countriesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CountriesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    CountriesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/countries/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const countriesContinentsList = <ThrowOnError extends boolean = false>(
  options?: Options<CountriesContinentsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    CountriesContinentsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/countries/continents',
    ...options
  })
}

export const countriesListList = <ThrowOnError extends boolean = false>(
  options?: Options<CountriesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    CountriesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/countries/list',
    ...options
  })
}

export const currenciesList = <ThrowOnError extends boolean = false>(
  options?: Options<CurrenciesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    CurrenciesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/currencies',
    ...options
  })
}

export const currenciesCreate = <ThrowOnError extends boolean = false>(
  options: Options<CurrenciesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CurrenciesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/currencies',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const currenciesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<CurrenciesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    CurrenciesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/currencies/{id}',
    ...options
  })
}

export const currenciesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<CurrenciesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    CurrenciesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/currencies/{id}',
    ...options
  })
}

export const currenciesPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CurrenciesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    CurrenciesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/currencies/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const currenciesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CurrenciesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    CurrenciesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/currencies/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const currenciesListList = <ThrowOnError extends boolean = false>(
  options?: Options<CurrenciesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    CurrenciesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/currencies/list',
    ...options
  })
}

export const customFieldsList = <ThrowOnError extends boolean = false>(
  options?: Options<CustomFieldsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    CustomFieldsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/custom-fields/',
    ...options
  })
}

export const customFieldsCreate = <ThrowOnError extends boolean = false>(
  options?: Options<CustomFieldsCreateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    CustomFieldsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/custom-fields/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const customFieldsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<CustomFieldsDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    CustomFieldsDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/custom-fields/{id}/',
    ...options
  })
}

export const customFieldsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<CustomFieldsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    CustomFieldsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/custom-fields/{id}/',
    ...options
  })
}

export const customFieldsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CustomFieldsPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    CustomFieldsPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/custom-fields/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const customFieldsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CustomFieldsUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    CustomFieldsUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/custom-fields/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const customFieldsUndeletePartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<CustomFieldsUndeletePartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    CustomFieldsUndeletePartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/custom-fields/{id}/undelete/',
    ...options
  })
}

export const dashboardLeadsList = <ThrowOnError extends boolean = false>(
  options?: Options<DashboardLeadsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    DashboardLeadsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/dashboard/leads',
    ...options
  })
}

export const dashboardReportsChartList = <ThrowOnError extends boolean = false>(
  options: Options<DashboardReportsChartListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    DashboardReportsChartListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/dashboard/reports-chart',
    ...options
  })
}

export const dashboardSalesReportList = <ThrowOnError extends boolean = false>(
  options?: Options<DashboardSalesReportListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    DashboardSalesReportListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/dashboard/sales-report',
    ...options
  })
}

/**
 * Retrieves and categorizes tasks for the current user or a specified user.
 *
 * This method organizes tasks into "past," "current," and "future" based on their deadline.
 * - **Admins, Billing, and Managers** can see tasks for any user (or filter by a specific user ID).
 * - Other users can only view their own tasks.
 *
 * Returns a dictionary with task counts and up to 3 serialized tasks for each category.
 */
export const dashboardTasksRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<DashboardTasksRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    DashboardTasksRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/dashboard/tasks',
    ...options
  })
}

export const dashboardTopExpertsList = <ThrowOnError extends boolean = false>(
  options?: Options<DashboardTopExpertsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    DashboardTopExpertsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/dashboard/top-experts',
    ...options
  })
}

export const documentCategoriesList = <ThrowOnError extends boolean = false>(
  options?: Options<DocumentCategoriesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    DocumentCategoriesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/document-categories',
    ...options
  })
}

export const documentCategoriesCreate = <ThrowOnError extends boolean = false>(
  options: Options<DocumentCategoriesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    DocumentCategoriesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/document-categories',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const documentCategoriesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<DocumentCategoriesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DocumentCategoriesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/document-categories/{id}',
    ...options
  })
}

export const documentCategoriesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<DocumentCategoriesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    DocumentCategoriesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/document-categories/{id}',
    ...options
  })
}

export const documentCategoriesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<DocumentCategoriesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    DocumentCategoriesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/document-categories/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const documentCategoriesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<DocumentCategoriesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    DocumentCategoriesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/document-categories/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const documentCategoriesListList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<DocumentCategoriesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    DocumentCategoriesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/document-categories/list',
    ...options
  })
}

export const documentsList = <ThrowOnError extends boolean = false>(
  options?: Options<DocumentsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    DocumentsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/documents',
    ...options
  })
}

export const documentsCreate = <ThrowOnError extends boolean = false>(
  options?: Options<DocumentsCreateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    DocumentsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/documents',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const documentsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<DocumentsDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DocumentsDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/documents/{id}',
    ...options
  })
}

export const documentsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DocumentsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    DocumentsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/documents/{id}',
    ...options
  })
}

export const documentsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<DocumentsPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    DocumentsPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/documents/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const documentsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<DocumentsUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    DocumentsUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/documents/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const documentsBulkCreateCreate = <ThrowOnError extends boolean = false>(
  options?: Options<DocumentsBulkCreateCreateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    DocumentsBulkCreateCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/documents/bulk-create',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const documentsListList = <ThrowOnError extends boolean = false>(
  options?: Options<DocumentsListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    DocumentsListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/documents/list',
    ...options
  })
}

export const expensesList = <ThrowOnError extends boolean = false>(
  options?: Options<ExpensesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ExpensesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/expenses',
    ...options
  })
}

export const expensesCreate = <ThrowOnError extends boolean = false>(
  options: Options<ExpensesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ExpensesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/expenses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const healthRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<HealthRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    HealthRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/health/',
    ...options
  })
}

export const industriesList = <ThrowOnError extends boolean = false>(
  options?: Options<IndustriesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    IndustriesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/industries',
    ...options
  })
}

export const industriesCreate = <ThrowOnError extends boolean = false>(
  options: Options<IndustriesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    IndustriesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/industries',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const industriesSubIndustriesList = <
  ThrowOnError extends boolean = false
>(
  options: Options<IndustriesSubIndustriesListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    IndustriesSubIndustriesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/industries/{industry_id}/sub-industries',
    ...options
  })
}

export const industriesSubIndustriesCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IndustriesSubIndustriesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    IndustriesSubIndustriesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/industries/{industry_id}/sub-industries',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const industriesSubIndustriesDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<IndustriesSubIndustriesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    IndustriesSubIndustriesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/industries/{industry_id}/sub-industries/{id}',
    ...options
  })
}

export const industriesSubIndustriesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<IndustriesSubIndustriesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    IndustriesSubIndustriesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/industries/{industry_id}/sub-industries/{id}',
    ...options
  })
}

export const industriesSubIndustriesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IndustriesSubIndustriesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    IndustriesSubIndustriesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/industries/{industry_id}/sub-industries/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const industriesSubIndustriesUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IndustriesSubIndustriesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    IndustriesSubIndustriesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/industries/{industry_id}/sub-industries/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const industriesSubIndustriesListList = <
  ThrowOnError extends boolean = false
>(
  options: Options<IndustriesSubIndustriesListListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    IndustriesSubIndustriesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/industries/{industry_id}/sub-industries/list',
    ...options
  })
}

export const industriesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<IndustriesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    IndustriesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/industries/{id}',
    ...options
  })
}

export const industriesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<IndustriesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    IndustriesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/industries/{id}',
    ...options
  })
}

export const industriesPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<IndustriesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    IndustriesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/industries/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const industriesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<IndustriesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    IndustriesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/industries/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const industriesListList = <ThrowOnError extends boolean = false>(
  options?: Options<IndustriesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    IndustriesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/industries/list',
    ...options
  })
}

export const informationList = <ThrowOnError extends boolean = false>(
  options?: Options<InformationListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InformationListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/information',
    ...options
  })
}

export const informationCreate = <ThrowOnError extends boolean = false>(
  options: Options<InformationCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InformationCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/information',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const informationDestroy = <ThrowOnError extends boolean = false>(
  options: Options<InformationDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    InformationDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/information/{id}',
    ...options
  })
}

export const informationRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<InformationRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InformationRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/information/{id}',
    ...options
  })
}

export const informationPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<InformationPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    InformationPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/information/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const informationUpdate = <ThrowOnError extends boolean = false>(
  options: Options<InformationUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    InformationUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/information/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const informationListList = <ThrowOnError extends boolean = false>(
  options?: Options<InformationListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InformationListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/information/list',
    ...options
  })
}

export const integrationsGmailList = <ThrowOnError extends boolean = false>(
  options?: Options<IntegrationsGmailListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    IntegrationsGmailListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/integrations/gmail',
    ...options
  })
}

export const integrationsGmailCreate = <ThrowOnError extends boolean = false>(
  options: Options<IntegrationsGmailCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    IntegrationsGmailCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/gmail',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const integrationsGmailDestroy = <ThrowOnError extends boolean = false>(
  options: Options<IntegrationsGmailDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    IntegrationsGmailDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/gmail/{id}',
    ...options
  })
}

export const integrationsGmailRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<IntegrationsGmailRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    IntegrationsGmailRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/gmail/{id}',
    ...options
  })
}

export const integrationsGmailPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationsGmailPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    IntegrationsGmailPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/gmail/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const integrationsGmailUpdate = <ThrowOnError extends boolean = false>(
  options: Options<IntegrationsGmailUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    IntegrationsGmailUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/gmail/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const integrationsGmailCheckMailboxRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationsGmailCheckMailboxRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    IntegrationsGmailCheckMailboxRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/gmail/{id}/check-mailbox',
    ...options
  })
}

export const integrationsGmailAuthCallbackCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationsGmailAuthCallbackCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    IntegrationsGmailAuthCallbackCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/gmail/auth-callback',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const integrationsGmailAuthUrlRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<IntegrationsGmailAuthUrlRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    IntegrationsGmailAuthUrlRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/gmail/auth-url',
    ...options
  })
}

export const integrationsGmailListList = <ThrowOnError extends boolean = false>(
  options?: Options<IntegrationsGmailListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    IntegrationsGmailListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/integrations/gmail/list',
    ...options
  })
}

export const integrationsGmailLogoutMailboxCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationsGmailLogoutMailboxCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    IntegrationsGmailLogoutMailboxCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/gmail/logout_mailbox',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const integrationsMessengerList = <ThrowOnError extends boolean = false>(
  options?: Options<IntegrationsMessengerListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    IntegrationsMessengerListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/integrations/messenger',
    ...options
  })
}

export const integrationsMessengerCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationsMessengerCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    IntegrationsMessengerCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/messenger',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const integrationsMessengerDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationsMessengerDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    IntegrationsMessengerDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/messenger/{id}',
    ...options
  })
}

export const integrationsMessengerRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationsMessengerRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    IntegrationsMessengerRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/messenger/{id}',
    ...options
  })
}

export const integrationsMessengerPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationsMessengerPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    IntegrationsMessengerPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/messenger/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const integrationsMessengerUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationsMessengerUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    IntegrationsMessengerUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/messenger/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const integrationsMessengerCheckMailboxRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationsMessengerCheckMailboxRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    IntegrationsMessengerCheckMailboxRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/messenger/{id}/check-mailbox',
    ...options
  })
}

export const integrationsMessengerAuthCallbackCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationsMessengerAuthCallbackCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    IntegrationsMessengerAuthCallbackCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/messenger/auth-callback',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const integrationsMessengerAuthUrlRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<IntegrationsMessengerAuthUrlRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    IntegrationsMessengerAuthUrlRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/messenger/auth-url',
    ...options
  })
}

export const integrationsMessengerListList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<IntegrationsMessengerListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    IntegrationsMessengerListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/integrations/messenger/list',
    ...options
  })
}

export const integrationsMessengerLogoutMailboxCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationsMessengerLogoutMailboxCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    IntegrationsMessengerLogoutMailboxCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/messenger/logout-mailbox',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const integrationsWhatsappConfigList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<IntegrationsWhatsappConfigListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    IntegrationsWhatsappConfigListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/integrations/whatsapp/config',
    ...options
  })
}

export const integrationsWhatsappConfigCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationsWhatsappConfigCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    IntegrationsWhatsappConfigCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/whatsapp/config',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const integrationsWhatsappConfigDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationsWhatsappConfigDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    IntegrationsWhatsappConfigDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/whatsapp/config/{id}',
    ...options
  })
}

export const integrationsWhatsappConfigRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationsWhatsappConfigRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    IntegrationsWhatsappConfigRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/whatsapp/config/{id}',
    ...options
  })
}

export const integrationsWhatsappConfigPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationsWhatsappConfigPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    IntegrationsWhatsappConfigPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/whatsapp/config/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const integrationsWhatsappConfigUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationsWhatsappConfigUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    IntegrationsWhatsappConfigUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/whatsapp/config/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const integrationsWhatsappConfigTestCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationsWhatsappConfigTestCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    IntegrationsWhatsappConfigTestCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/whatsapp/config/{id}/test',
    ...options
  })
}

export const integrationsWhatsappMessageTemplatesList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<IntegrationsWhatsappMessageTemplatesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    IntegrationsWhatsappMessageTemplatesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/integrations/whatsapp/message-templates',
    ...options
  })
}

export const integrationsWhatsappMessageTemplatesSyncCreate = <
  ThrowOnError extends boolean = false
>(
  options?: Options<
    IntegrationsWhatsappMessageTemplatesSyncCreateData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).post<
    IntegrationsWhatsappMessageTemplatesSyncCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/whatsapp/message-templates/sync',
    ...options
  })
}

export const integrationsWhatsappMessagesList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<IntegrationsWhatsappMessagesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    IntegrationsWhatsappMessagesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/integrations/whatsapp/messages',
    ...options
  })
}

export const integrationsWhatsappMessagesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationsWhatsappMessagesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    IntegrationsWhatsappMessagesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/whatsapp/messages/{id}',
    ...options
  })
}

export const integrationsWhatsappMessagesRetryCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationsWhatsappMessagesRetryCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    IntegrationsWhatsappMessagesRetryCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/whatsapp/messages/{id}/retry',
    ...options
  })
}

export const integrationsWhatsappMessagesSendCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<IntegrationsWhatsappMessagesSendCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    IntegrationsWhatsappMessagesSendCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/integrations/whatsapp/messages/send',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalCitiesList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalCitiesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalCitiesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/cities',
    ...options
  })
}

export const internalCitiesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<InternalCitiesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalCitiesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/cities/{id}',
    ...options
  })
}

export const internalCitiesListList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalCitiesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalCitiesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/cities/list',
    ...options
  })
}

export const internalCompanySizesList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalCompanySizesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalCompanySizesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/company-sizes',
    ...options
  })
}

export const internalCompanySizesCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalCompanySizesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InternalCompanySizesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/company-sizes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalCompanySizesDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalCompanySizesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    InternalCompanySizesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/company-sizes/{id}',
    ...options
  })
}

export const internalCompanySizesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalCompanySizesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalCompanySizesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/company-sizes/{id}',
    ...options
  })
}

export const internalCompanySizesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalCompanySizesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    InternalCompanySizesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/company-sizes/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalCompanySizesUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalCompanySizesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    InternalCompanySizesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/company-sizes/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalCompanySizesListList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<InternalCompanySizesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalCompanySizesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/company-sizes/list',
    ...options
  })
}

export const internalContactsList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalContactsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalContactsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/contacts',
    ...options
  })
}

export const internalContactsCreate = <ThrowOnError extends boolean = false>(
  options?: Options<InternalContactsCreateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    InternalContactsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/contacts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalContactsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<InternalContactsDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    InternalContactsDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/contacts/{id}',
    ...options
  })
}

export const internalContactsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<InternalContactsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalContactsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/contacts/{id}',
    ...options
  })
}

export const internalContactsPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalContactsPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    InternalContactsPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/contacts/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalContactsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<InternalContactsUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    InternalContactsUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/contacts/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

/**
 * Get contact connection graph
 * Returns graph nodes representing all contact connections such as leads and opportunities.
 */
export const internalContactsConnectionsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalContactsConnectionsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalContactsConnectionsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/contacts/{id}/connections',
    ...options
  })
}

export const internalContactsInitCallCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalContactsInitCallCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InternalContactsInitCallCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/contacts/{id}/init-call',
    ...options
  })
}

export const internalContactsPhoneNumbersList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<InternalContactsPhoneNumbersListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalContactsPhoneNumbersListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/contacts/phone-numbers',
    ...options
  })
}

export const internalContactsPhoneNumbersCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalContactsPhoneNumbersCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InternalContactsPhoneNumbersCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/contacts/phone-numbers',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalContactsPhoneNumbersDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalContactsPhoneNumbersDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    InternalContactsPhoneNumbersDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/contacts/phone-numbers/{id}',
    ...options
  })
}

export const internalContactsPhoneNumbersRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalContactsPhoneNumbersRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalContactsPhoneNumbersRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/contacts/phone-numbers/{id}',
    ...options
  })
}

export const internalContactsPhoneNumbersPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalContactsPhoneNumbersPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    InternalContactsPhoneNumbersPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/contacts/phone-numbers/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalContactsPhoneNumbersUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalContactsPhoneNumbersUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    InternalContactsPhoneNumbersUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/contacts/phone-numbers/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalCountriesList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalCountriesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalCountriesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/countries',
    ...options
  })
}

export const internalCountriesCreate = <ThrowOnError extends boolean = false>(
  options: Options<InternalCountriesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InternalCountriesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/countries',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalCountriesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<InternalCountriesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    InternalCountriesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/countries/{id}',
    ...options
  })
}

export const internalCountriesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<InternalCountriesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalCountriesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/countries/{id}',
    ...options
  })
}

export const internalCountriesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalCountriesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    InternalCountriesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/countries/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalCountriesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<InternalCountriesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    InternalCountriesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/countries/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalCountriesContinentsList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<InternalCountriesContinentsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalCountriesContinentsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/countries/continents',
    ...options
  })
}

export const internalCountriesListList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalCountriesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalCountriesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/countries/list',
    ...options
  })
}

export const internalCurrenciesList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalCurrenciesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalCurrenciesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/currencies',
    ...options
  })
}

export const internalCurrenciesCreate = <ThrowOnError extends boolean = false>(
  options: Options<InternalCurrenciesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InternalCurrenciesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/currencies',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalCurrenciesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<InternalCurrenciesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    InternalCurrenciesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/currencies/{id}',
    ...options
  })
}

export const internalCurrenciesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalCurrenciesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalCurrenciesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/currencies/{id}',
    ...options
  })
}

export const internalCurrenciesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalCurrenciesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    InternalCurrenciesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/currencies/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalCurrenciesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<InternalCurrenciesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    InternalCurrenciesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/currencies/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalCurrenciesListList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<InternalCurrenciesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalCurrenciesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/currencies/list',
    ...options
  })
}

export const internalIndustriesList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalIndustriesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalIndustriesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/industries',
    ...options
  })
}

export const internalIndustriesCreate = <ThrowOnError extends boolean = false>(
  options: Options<InternalIndustriesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InternalIndustriesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/industries',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalIndustriesSubIndustriesList = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalIndustriesSubIndustriesListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalIndustriesSubIndustriesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/industries/{industry_id}/sub-industries',
    ...options
  })
}

export const internalIndustriesSubIndustriesCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalIndustriesSubIndustriesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InternalIndustriesSubIndustriesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/industries/{industry_id}/sub-industries',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalIndustriesSubIndustriesDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalIndustriesSubIndustriesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    InternalIndustriesSubIndustriesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/industries/{industry_id}/sub-industries/{id}',
    ...options
  })
}

export const internalIndustriesSubIndustriesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalIndustriesSubIndustriesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalIndustriesSubIndustriesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/industries/{industry_id}/sub-industries/{id}',
    ...options
  })
}

export const internalIndustriesSubIndustriesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    InternalIndustriesSubIndustriesPartialUpdateData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).patch<
    InternalIndustriesSubIndustriesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/industries/{industry_id}/sub-industries/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalIndustriesSubIndustriesUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalIndustriesSubIndustriesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    InternalIndustriesSubIndustriesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/industries/{industry_id}/sub-industries/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalIndustriesSubIndustriesListList = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalIndustriesSubIndustriesListListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalIndustriesSubIndustriesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/industries/{industry_id}/sub-industries/list',
    ...options
  })
}

export const internalIndustriesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<InternalIndustriesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    InternalIndustriesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/industries/{id}',
    ...options
  })
}

export const internalIndustriesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalIndustriesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalIndustriesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/industries/{id}',
    ...options
  })
}

export const internalIndustriesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalIndustriesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    InternalIndustriesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/industries/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalIndustriesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<InternalIndustriesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    InternalIndustriesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/industries/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalIndustriesListList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<InternalIndustriesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalIndustriesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/industries/list',
    ...options
  })
}

export const internalLeadsList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalLeadsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalLeadsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/leads',
    ...options
  })
}

export const internalLeadsCreate = <ThrowOnError extends boolean = false>(
  options: Options<InternalLeadsCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InternalLeadsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/leads',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalLeadsStatusesList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalLeadsStatusesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalLeadsStatusesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/leads-statuses',
    ...options
  })
}

export const internalLeadsStatusesCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalLeadsStatusesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InternalLeadsStatusesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/leads-statuses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalLeadsStatusesDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalLeadsStatusesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    InternalLeadsStatusesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/leads-statuses/{id}',
    ...options
  })
}

export const internalLeadsStatusesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalLeadsStatusesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalLeadsStatusesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/leads-statuses/{id}',
    ...options
  })
}

export const internalLeadsStatusesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalLeadsStatusesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    InternalLeadsStatusesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/leads-statuses/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalLeadsStatusesUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalLeadsStatusesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    InternalLeadsStatusesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/leads-statuses/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalLeadsStatusesListList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<InternalLeadsStatusesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalLeadsStatusesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/leads-statuses/list',
    ...options
  })
}

export const internalLeadsTypesList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalLeadsTypesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalLeadsTypesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/leads-types',
    ...options
  })
}

export const internalLeadsTypesCreate = <ThrowOnError extends boolean = false>(
  options: Options<InternalLeadsTypesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InternalLeadsTypesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/leads-types',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalLeadsTypesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<InternalLeadsTypesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    InternalLeadsTypesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/leads-types/{id}',
    ...options
  })
}

export const internalLeadsTypesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalLeadsTypesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalLeadsTypesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/leads-types/{id}',
    ...options
  })
}

export const internalLeadsTypesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalLeadsTypesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    InternalLeadsTypesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/leads-types/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalLeadsTypesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<InternalLeadsTypesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    InternalLeadsTypesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/leads-types/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalLeadsTypesListList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<InternalLeadsTypesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalLeadsTypesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/leads-types/list',
    ...options
  })
}

export const internalLeadsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<InternalLeadsDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    InternalLeadsDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/leads/{id}',
    ...options
  })
}

export const internalLeadsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<InternalLeadsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalLeadsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/leads/{id}',
    ...options
  })
}

export const internalLeadsPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalLeadsPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    InternalLeadsPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/leads/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalLeadsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<InternalLeadsUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    InternalLeadsUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/leads/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalLeadsListList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalLeadsListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalLeadsListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/leads/list',
    ...options
  })
}

export const internalLogsList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalLogsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalLogsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/logs',
    ...options
  })
}

export const internalLogsCreate = <ThrowOnError extends boolean = false>(
  options: Options<InternalLogsCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InternalLogsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/logs',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalLogsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<InternalLogsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalLogsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/logs/{id}',
    ...options
  })
}

export const internalOpportunitiesCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalOpportunitiesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InternalOpportunitiesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/opportunities',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalOpportunitiesStatusesList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<InternalOpportunitiesStatusesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalOpportunitiesStatusesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/opportunities-statuses',
    ...options
  })
}

export const internalOpportunitiesStatusesCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalOpportunitiesStatusesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InternalOpportunitiesStatusesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/opportunities-statuses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalOpportunitiesStatusesDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalOpportunitiesStatusesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    InternalOpportunitiesStatusesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/opportunities-statuses/{id}',
    ...options
  })
}

export const internalOpportunitiesStatusesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalOpportunitiesStatusesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalOpportunitiesStatusesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/opportunities-statuses/{id}',
    ...options
  })
}

export const internalOpportunitiesStatusesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalOpportunitiesStatusesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    InternalOpportunitiesStatusesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/opportunities-statuses/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalOpportunitiesStatusesUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalOpportunitiesStatusesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    InternalOpportunitiesStatusesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/opportunities-statuses/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalOpportunitiesStatusesListList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<InternalOpportunitiesStatusesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalOpportunitiesStatusesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/opportunities-statuses/list',
    ...options
  })
}

export const internalOpportunitiesDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalOpportunitiesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    InternalOpportunitiesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/opportunities/{id}',
    ...options
  })
}

export const internalOpportunitiesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalOpportunitiesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalOpportunitiesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/opportunities/{id}',
    ...options
  })
}

export const internalOpportunitiesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalOpportunitiesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    InternalOpportunitiesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/opportunities/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalOpportunitiesUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalOpportunitiesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    InternalOpportunitiesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/opportunities/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalProductsList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalProductsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalProductsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/products',
    ...options
  })
}

export const internalProductsCreate = <ThrowOnError extends boolean = false>(
  options: Options<InternalProductsCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InternalProductsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/products',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalProductsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<InternalProductsDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    InternalProductsDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/products/{id}',
    ...options
  })
}

export const internalProductsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<InternalProductsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalProductsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/products/{id}',
    ...options
  })
}

export const internalProductsPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalProductsPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    InternalProductsPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/products/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalProductsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<InternalProductsUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    InternalProductsUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/products/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalProductsListList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalProductsListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalProductsListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/products/list',
    ...options
  })
}

export const internalReasonsList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalReasonsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalReasonsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/reasons',
    ...options
  })
}

export const internalReasonsCreate = <ThrowOnError extends boolean = false>(
  options: Options<InternalReasonsCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InternalReasonsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/reasons',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalReasonsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<InternalReasonsDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    InternalReasonsDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/reasons/{id}',
    ...options
  })
}

export const internalReasonsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<InternalReasonsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalReasonsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/reasons/{id}',
    ...options
  })
}

export const internalReasonsPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalReasonsPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    InternalReasonsPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/reasons/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalReasonsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<InternalReasonsUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    InternalReasonsUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/reasons/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalReasonsListList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalReasonsListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalReasonsListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/reasons/list',
    ...options
  })
}

export const internalRegionsList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalRegionsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalRegionsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/regions',
    ...options
  })
}

export const internalRegionsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<InternalRegionsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalRegionsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/regions/{id}',
    ...options
  })
}

export const internalRegionsListList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalRegionsListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalRegionsListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/regions/list',
    ...options
  })
}

export const internalSequencesList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalSequencesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalSequencesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/sequences',
    ...options
  })
}

export const internalSequencesCreate = <ThrowOnError extends boolean = false>(
  options?: Options<InternalSequencesCreateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    InternalSequencesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/sequences',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalSequencesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<InternalSequencesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    InternalSequencesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/sequences/{id}',
    ...options
  })
}

export const internalSequencesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<InternalSequencesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalSequencesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/sequences/{id}',
    ...options
  })
}

export const internalSequencesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalSequencesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    InternalSequencesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/sequences/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalSequencesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<InternalSequencesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    InternalSequencesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/sequences/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalSequencesAddLeadsCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalSequencesAddLeadsCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InternalSequencesAddLeadsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/sequences/{id}/add-leads',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalSequencesDuplicateRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalSequencesDuplicateRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalSequencesDuplicateRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/sequences/{id}/duplicate',
    ...options
  })
}

export const internalSequencesListList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalSequencesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalSequencesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/sequences/list',
    ...options
  })
}

export const internalSourcesList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalSourcesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalSourcesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/sources',
    ...options
  })
}

export const internalSourcesCreate = <ThrowOnError extends boolean = false>(
  options: Options<InternalSourcesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InternalSourcesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/sources',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalSourcesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<InternalSourcesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    InternalSourcesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/sources/{id}',
    ...options
  })
}

export const internalSourcesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<InternalSourcesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalSourcesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/sources/{id}',
    ...options
  })
}

export const internalSourcesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalSourcesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    InternalSourcesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/sources/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalSourcesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<InternalSourcesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    InternalSourcesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/sources/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalSourcesListList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalSourcesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalSourcesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/sources/list',
    ...options
  })
}

export const internalTagsList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalTagsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalTagsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/tags',
    ...options
  })
}

export const internalTagsCreate = <ThrowOnError extends boolean = false>(
  options: Options<InternalTagsCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InternalTagsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/tags',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalTagsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<InternalTagsDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    InternalTagsDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/tags/{id}',
    ...options
  })
}

export const internalTagsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<InternalTagsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalTagsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/tags/{id}',
    ...options
  })
}

export const internalTagsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<InternalTagsPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    InternalTagsPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/tags/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalTagsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<InternalTagsUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    InternalTagsUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/tags/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalTagsColorsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<InternalTagsColorsRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalTagsColorsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/tags/colors',
    ...options
  })
}

export const internalTagsListList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalTagsListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalTagsListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/tags/list',
    ...options
  })
}

export const internalTaskTypesList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalTaskTypesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalTaskTypesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/task-types',
    ...options
  })
}

export const internalTaskTypesCreate = <ThrowOnError extends boolean = false>(
  options: Options<InternalTaskTypesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InternalTaskTypesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/task-types',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalTaskTypesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<InternalTaskTypesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    InternalTaskTypesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/task-types/{id}',
    ...options
  })
}

export const internalTaskTypesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<InternalTaskTypesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InternalTaskTypesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/task-types/{id}',
    ...options
  })
}

export const internalTaskTypesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InternalTaskTypesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    InternalTaskTypesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/task-types/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalTaskTypesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<InternalTaskTypesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    InternalTaskTypesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/task-types/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const internalTaskTypesAllRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<InternalTaskTypesAllRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalTaskTypesAllRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/internal/task-types/all',
    ...options
  })
}

export const internalTaskTypesListList = <ThrowOnError extends boolean = false>(
  options?: Options<InternalTaskTypesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalTaskTypesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/internal/task-types/list',
    ...options
  })
}

export const invoicesList = <ThrowOnError extends boolean = false>(
  options?: Options<InvoicesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InvoicesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/invoices',
    ...options
  })
}

export const invoicesCreate = <ThrowOnError extends boolean = false>(
  options: Options<InvoicesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InvoicesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/invoices',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const invoicesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<InvoicesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    InvoicesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/invoices/{id}',
    ...options
  })
}

export const invoicesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<InvoicesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InvoicesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/invoices/{id}',
    ...options
  })
}

export const invoicesPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<InvoicesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    InvoicesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/invoices/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const invoicesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<InvoicesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    InvoicesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/invoices/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const invoicesChangeStatusPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InvoicesChangeStatusPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    InvoicesChangeStatusPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/invoices/{id}/change-status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const invoicesDownloadRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<InvoicesDownloadRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InvoicesDownloadRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'blob',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/invoices/{id}/download',
    ...options
  })
}

export const invoicesEmailRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<InvoicesEmailRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    InvoicesEmailRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/invoices/{id}/email',
    ...options
  })
}

export const invoicesResendEmailRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<InvoicesResendEmailRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/invoices/{id}/resend-email',
    ...options
  })
}

export const invoicesContractorsCreate = <ThrowOnError extends boolean = false>(
  options: Options<InvoicesContractorsCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InvoicesContractorsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/invoices/contractors',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const invoicesReportsRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<InvoicesReportsRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InvoicesReportsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/invoices/reports',
    ...options
  })
}

export const invoicesReportsExportCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<InvoicesReportsExportCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InvoicesReportsExportCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/invoices/reports-export',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const invoicesSettingsRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<InvoicesSettingsRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InvoicesSettingsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/invoices/settings',
    ...options
  })
}

export const invoicesSettingsCreate = <ThrowOnError extends boolean = false>(
  options: Options<InvoicesSettingsCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InvoicesSettingsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/invoices/settings',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadGenerationCampaignsList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<LeadGenerationCampaignsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    LeadGenerationCampaignsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/lead-generation/campaigns',
    ...options
  })
}

export const leadGenerationCampaignsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<LeadGenerationCampaignsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LeadGenerationCampaignsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/lead-generation/campaigns/{generator_key}',
    ...options
  })
}

export const leadGenerationCampaignsPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<LeadGenerationCampaignsPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    LeadGenerationCampaignsPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/lead-generation/campaigns/{generator_key}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

/**
 * List this campaign's runs, most recent first (paginated).
 */
export const leadGenerationCampaignsRunsList = <
  ThrowOnError extends boolean = false
>(
  options: Options<LeadGenerationCampaignsRunsListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LeadGenerationCampaignsRunsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/lead-generation/campaigns/{generator_key}/runs',
    ...options
  })
}

/**
 * Start a manual run for the campaign, using the same logic as the scheduled run.
 */
export const leadGenerationCampaignsTriggerCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<LeadGenerationCampaignsTriggerCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    LeadGenerationCampaignsTriggerCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/lead-generation/campaigns/{generator_key}/trigger',
    ...options
  })
}

export const leadGenerationRunsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<LeadGenerationRunsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LeadGenerationRunsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/lead-generation/runs/{id}',
    ...options
  })
}

export const leadScoreList = <ThrowOnError extends boolean = false>(
  options?: Options<LeadScoreListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    LeadScoreListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/lead-score',
    ...options
  })
}

export const leadScoreCreate = <ThrowOnError extends boolean = false>(
  options: Options<LeadScoreCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    LeadScoreCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/lead-score',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadScoreDestroy = <ThrowOnError extends boolean = false>(
  options: Options<LeadScoreDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    LeadScoreDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/lead-score/{id}',
    ...options
  })
}

export const leadScoreRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<LeadScoreRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LeadScoreRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/lead-score/{id}',
    ...options
  })
}

export const leadScorePartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<LeadScorePartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    LeadScorePartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/lead-score/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadScoreUpdate = <ThrowOnError extends boolean = false>(
  options: Options<LeadScoreUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    LeadScoreUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/lead-score/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadScoreFieldsRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<LeadScoreFieldsRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    LeadScoreFieldsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/lead-score/fields',
    ...options
  })
}

export const leadScoreListList = <ThrowOnError extends boolean = false>(
  options?: Options<LeadScoreListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    LeadScoreListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/lead-score/list',
    ...options
  })
}

export const leadsList = <ThrowOnError extends boolean = false>(
  options?: Options<LeadsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    LeadsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/leads',
    ...options
  })
}

export const leadsCreate = <ThrowOnError extends boolean = false>(
  options?: Options<LeadsCreateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    LeadsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsImportList = <ThrowOnError extends boolean = false>(
  options?: Options<LeadsImportListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    LeadsImportListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/leads-import',
    ...options
  })
}

export const leadsImportCreate = <ThrowOnError extends boolean = false>(
  options?: Options<LeadsImportCreateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    LeadsImportCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads-import',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsImportDestroy = <ThrowOnError extends boolean = false>(
  options: Options<LeadsImportDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    LeadsImportDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads-import/{id}',
    ...options
  })
}

export const leadsImportRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<LeadsImportRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LeadsImportRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads-import/{id}',
    ...options
  })
}

export const leadsImportPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<LeadsImportPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    LeadsImportPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads-import/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsImportUpdate = <ThrowOnError extends boolean = false>(
  options: Options<LeadsImportUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    LeadsImportUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads-import/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsImportColumnUniqueValuesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<LeadsImportColumnUniqueValuesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LeadsImportColumnUniqueValuesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads-import/{id}/column-unique-values',
    ...options
  })
}

/**
 * Endpoint for getting preview from csv/excel files
 */
export const leadsImportPreviewRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<LeadsImportPreviewRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LeadsImportPreviewRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads-import/{id}/preview',
    ...options
  })
}

/**
 * Returns lead and contact header fields for file preview
 */
export const leadsImportHeadersRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<LeadsImportHeadersRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    LeadsImportHeadersRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads-import/headers',
    ...options
  })
}

/**
 * Endpoint for getting unique fields for file check duplicates
 */
export const leadsImportUniqueFieldsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<LeadsImportUniqueFieldsRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    LeadsImportUniqueFieldsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads-import/unique-fields',
    ...options
  })
}

export const leadsStatusesList = <ThrowOnError extends boolean = false>(
  options?: Options<LeadsStatusesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    LeadsStatusesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/leads-statuses',
    ...options
  })
}

export const leadsStatusesCreate = <ThrowOnError extends boolean = false>(
  options: Options<LeadsStatusesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    LeadsStatusesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads-statuses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsStatusesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<LeadsStatusesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    LeadsStatusesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads-statuses/{id}',
    ...options
  })
}

export const leadsStatusesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<LeadsStatusesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LeadsStatusesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads-statuses/{id}',
    ...options
  })
}

export const leadsStatusesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<LeadsStatusesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    LeadsStatusesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads-statuses/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsStatusesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<LeadsStatusesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    LeadsStatusesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads-statuses/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsStatusesListList = <ThrowOnError extends boolean = false>(
  options?: Options<LeadsStatusesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    LeadsStatusesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/leads-statuses/list',
    ...options
  })
}

export const leadsTypesList = <ThrowOnError extends boolean = false>(
  options?: Options<LeadsTypesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    LeadsTypesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/leads-types',
    ...options
  })
}

export const leadsTypesCreate = <ThrowOnError extends boolean = false>(
  options: Options<LeadsTypesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    LeadsTypesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads-types',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsTypesLeadsStatusesList = <
  ThrowOnError extends boolean = false
>(
  options: Options<LeadsTypesLeadsStatusesListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LeadsTypesLeadsStatusesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/leads-types/{lead_type_id}/leads-statuses',
    ...options
  })
}

export const leadsTypesLeadsStatusesCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<LeadsTypesLeadsStatusesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    LeadsTypesLeadsStatusesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads-types/{lead_type_id}/leads-statuses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsTypesLeadsStatusesDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<LeadsTypesLeadsStatusesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    LeadsTypesLeadsStatusesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads-types/{lead_type_id}/leads-statuses/{id}',
    ...options
  })
}

export const leadsTypesLeadsStatusesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<LeadsTypesLeadsStatusesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LeadsTypesLeadsStatusesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads-types/{lead_type_id}/leads-statuses/{id}',
    ...options
  })
}

export const leadsTypesLeadsStatusesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<LeadsTypesLeadsStatusesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    LeadsTypesLeadsStatusesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads-types/{lead_type_id}/leads-statuses/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsTypesLeadsStatusesUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<LeadsTypesLeadsStatusesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    LeadsTypesLeadsStatusesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads-types/{lead_type_id}/leads-statuses/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsTypesLeadsStatusesListList = <
  ThrowOnError extends boolean = false
>(
  options: Options<LeadsTypesLeadsStatusesListListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LeadsTypesLeadsStatusesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/leads-types/{lead_type_id}/leads-statuses/list',
    ...options
  })
}

export const leadsTypesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<LeadsTypesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    LeadsTypesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads-types/{id}',
    ...options
  })
}

export const leadsTypesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<LeadsTypesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LeadsTypesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads-types/{id}',
    ...options
  })
}

export const leadsTypesPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<LeadsTypesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    LeadsTypesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads-types/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsTypesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<LeadsTypesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    LeadsTypesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads-types/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsTypesListList = <ThrowOnError extends boolean = false>(
  options?: Options<LeadsTypesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    LeadsTypesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/leads-types/list',
    ...options
  })
}

export const leadsContactsList = <ThrowOnError extends boolean = false>(
  options: Options<LeadsContactsListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LeadsContactsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/leads/{lead_id}/contacts',
    ...options
  })
}

export const leadsContractsList = <ThrowOnError extends boolean = false>(
  options: Options<LeadsContractsListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LeadsContractsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/leads/{lead_id}/contracts',
    ...options
  })
}

export const leadsDocumentsList = <ThrowOnError extends boolean = false>(
  options: Options<LeadsDocumentsListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LeadsDocumentsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/leads/{lead_id}/documents',
    ...options
  })
}

export const leadsLogsList = <ThrowOnError extends boolean = false>(
  options: Options<LeadsLogsListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LeadsLogsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/leads/{lead_id}/logs',
    ...options
  })
}

export const leadsOpportunitiesList = <ThrowOnError extends boolean = false>(
  options: Options<LeadsOpportunitiesListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LeadsOpportunitiesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/leads/{lead_id}/opportunities',
    ...options
  })
}

export const leadsSequencesList = <ThrowOnError extends boolean = false>(
  options: Options<LeadsSequencesListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LeadsSequencesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads/{lead_id}/sequences',
    ...options
  })
}

export const leadsSequencesCreate = <ThrowOnError extends boolean = false>(
  options: Options<LeadsSequencesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    LeadsSequencesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads/{lead_id}/sequences',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsSequencesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<LeadsSequencesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    LeadsSequencesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads/{lead_id}/sequences/{sequence}',
    ...options
  })
}

export const leadsSequencesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<LeadsSequencesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LeadsSequencesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads/{lead_id}/sequences/{sequence}',
    ...options
  })
}

export const leadsSequencesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<LeadsSequencesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    LeadsSequencesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads/{lead_id}/sequences/{sequence}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsSequencesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<LeadsSequencesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    LeadsSequencesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads/{lead_id}/sequences/{sequence}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsTasksList = <ThrowOnError extends boolean = false>(
  options: Options<LeadsTasksListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LeadsTasksListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/leads/{lead_id}/tasks',
    ...options
  })
}

export const leadsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<LeadsDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    LeadsDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads/{id}',
    ...options
  })
}

export const leadsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<LeadsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LeadsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads/{id}',
    ...options
  })
}

export const leadsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<LeadsPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    LeadsPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<LeadsUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    LeadsUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsConvertToClientCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<LeadsConvertToClientCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    LeadsConvertToClientCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads/{id}/convert-to-client',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsInvoiceContactsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<LeadsInvoiceContactsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LeadsInvoiceContactsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads/{id}/invoice-contacts',
    ...options
  })
}

export const leadsInvoicesList = <ThrowOnError extends boolean = false>(
  options: Options<LeadsInvoicesListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LeadsInvoicesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/leads/{id}/invoices',
    ...options
  })
}

export const leadsMergePartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<LeadsMergePartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    LeadsMergePartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads/{id}/merge',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsSimilarRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<LeadsSimilarRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LeadsSimilarRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads/{id}/similar',
    ...options
  })
}

export const leadsUndeletePartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<LeadsUndeletePartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    LeadsUndeletePartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads/{id}/undelete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsBulkAssigneePartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options?: Options<LeadsBulkAssigneePartialUpdateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).patch<
    LeadsBulkAssigneePartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads/bulk-assignee',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsBulkDeleteCreate = <ThrowOnError extends boolean = false>(
  options: Options<LeadsBulkDeleteCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    LeadsBulkDeleteCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads/bulk-delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsBulkSetBranchPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options?: Options<LeadsBulkSetBranchPartialUpdateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).patch<
    LeadsBulkSetBranchPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads/bulk-set-branch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsDeletedList = <ThrowOnError extends boolean = false>(
  options?: Options<LeadsDeletedListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    LeadsDeletedListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/leads/deleted',
    ...options
  })
}

export const leadsExportRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<LeadsExportRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    LeadsExportRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/leads/export',
    ...options
  })
}

export const leadsListList = <ThrowOnError extends boolean = false>(
  options?: Options<LeadsListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    LeadsListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/leads/list',
    ...options
  })
}

export const leadsPipelineList = <ThrowOnError extends boolean = false>(
  options?: Options<LeadsPipelineListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    LeadsPipelineListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/leads/pipeline',
    ...options
  })
}

export const leadsSetTagPartialUpdate = <ThrowOnError extends boolean = false>(
  options?: Options<LeadsSetTagPartialUpdateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).patch<
    LeadsSetTagPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/leads/set-tag',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const leadsViewedList = <ThrowOnError extends boolean = false>(
  options?: Options<LeadsViewedListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    LeadsViewedListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/leads/viewed',
    ...options
  })
}

export const listViewsList = <ThrowOnError extends boolean = false>(
  options?: Options<ListViewsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ListViewsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/list-views',
    ...options
  })
}

export const listViewsCreate = <ThrowOnError extends boolean = false>(
  options?: Options<ListViewsCreateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    ListViewsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/list-views',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const listViewsResultList = <ThrowOnError extends boolean = false>(
  options: Options<ListViewsResultListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListViewsResultListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/list-views/{list_id}/result',
    ...options
  })
}

export const listViewsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ListViewsDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    ListViewsDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/list-views/{id}',
    ...options
  })
}

export const listViewsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ListViewsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListViewsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/list-views/{id}',
    ...options
  })
}

export const listViewsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ListViewsPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    ListViewsPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/list-views/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const listViewsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ListViewsUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    ListViewsUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/list-views/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const listViewsFieldsRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<ListViewsFieldsRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ListViewsFieldsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/list-views/fields',
    ...options
  })
}

export const logsList = <ThrowOnError extends boolean = false>(
  options?: Options<LogsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    LogsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/logs',
    ...options
  })
}

export const logsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<LogsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LogsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/logs/{id}',
    ...options
  })
}

export const logsMeetingCreate = <ThrowOnError extends boolean = false>(
  options: Options<LogsMeetingCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    LogsMeetingCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/logs/meeting',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const logsNoteCreate = <ThrowOnError extends boolean = false>(
  options: Options<LogsNoteCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    LogsNoteCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/logs/note',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const mailboxesList = <ThrowOnError extends boolean = false>(
  options?: Options<MailboxesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    MailboxesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/mailboxes',
    ...options
  })
}

export const mailboxesCreate = <ThrowOnError extends boolean = false>(
  options: Options<MailboxesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    MailboxesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/mailboxes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const mailboxesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<MailboxesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    MailboxesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/mailboxes/{id}',
    ...options
  })
}

export const mailboxesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<MailboxesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    MailboxesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/mailboxes/{id}',
    ...options
  })
}

export const mailboxesPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<MailboxesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    MailboxesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/mailboxes/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const mailboxesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<MailboxesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    MailboxesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/mailboxes/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const mailboxesCheckMailboxRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<MailboxesCheckMailboxRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    MailboxesCheckMailboxRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/mailboxes/{id}/check-mailbox',
    ...options
  })
}

export const mailboxesLoginRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<MailboxesLoginRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    MailboxesLoginRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/mailboxes/{id}/login',
    ...options
  })
}

export const mailboxesListList = <ThrowOnError extends boolean = false>(
  options?: Options<MailboxesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    MailboxesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/mailboxes/list',
    ...options
  })
}

export const mailboxesOauthLogoutCreate = <
  ThrowOnError extends boolean = false
>(
  options?: Options<MailboxesOauthLogoutCreateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    MailboxesOauthLogoutCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/mailboxes/oauth/logout',
    ...options
  })
}

export const mailboxesOauthLogoutLinkRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<MailboxesOauthLogoutLinkRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    MailboxesOauthLogoutLinkRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/mailboxes/oauth/logout-link',
    ...options
  })
}

export const mailboxesOauthOutlookCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<MailboxesOauthOutlookCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    MailboxesOauthOutlookCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/mailboxes/oauth/outlook',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const mailboxesOutlookLinkRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<MailboxesOutlookLinkRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    MailboxesOutlookLinkRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/mailboxes/outlook-link',
    ...options
  })
}

export const mailboxesSendEmailCreate = <ThrowOnError extends boolean = false>(
  options: Options<MailboxesSendEmailCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          name: 'Authorization',
          type: 'apiKey'
        },
        {
          name: 'Saas-app-token',
          type: 'apiKey'
        }
      ],
      url: '/mailboxes/send-email',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers
      }
    }
  )
}

export const mailboxesTemplatesList = <ThrowOnError extends boolean = false>(
  options?: Options<MailboxesTemplatesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    MailboxesTemplatesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/mailboxes/templates',
    ...options
  })
}

export const mailboxesTemplatesCreate = <ThrowOnError extends boolean = false>(
  options: Options<MailboxesTemplatesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    MailboxesTemplatesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/mailboxes/templates',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const mailboxesTemplatesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<MailboxesTemplatesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    MailboxesTemplatesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/mailboxes/templates/{id}',
    ...options
  })
}

export const mailboxesTemplatesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<MailboxesTemplatesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    MailboxesTemplatesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/mailboxes/templates/{id}',
    ...options
  })
}

export const mailboxesTemplatesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<MailboxesTemplatesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    MailboxesTemplatesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/mailboxes/templates/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const mailboxesTemplatesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<MailboxesTemplatesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    MailboxesTemplatesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/mailboxes/templates/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const opportunitiesList = <ThrowOnError extends boolean = false>(
  options?: Options<OpportunitiesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    OpportunitiesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/opportunities',
    ...options
  })
}

export const opportunitiesCreate = <ThrowOnError extends boolean = false>(
  options?: Options<OpportunitiesCreateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    OpportunitiesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const opportunitiesStatusesList = <ThrowOnError extends boolean = false>(
  options?: Options<OpportunitiesStatusesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    OpportunitiesStatusesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/opportunities-statuses',
    ...options
  })
}

export const opportunitiesStatusesCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesStatusesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    OpportunitiesStatusesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities-statuses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const opportunitiesStatusesDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesStatusesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    OpportunitiesStatusesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities-statuses/{id}',
    ...options
  })
}

export const opportunitiesStatusesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesStatusesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    OpportunitiesStatusesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities-statuses/{id}',
    ...options
  })
}

export const opportunitiesStatusesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesStatusesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    OpportunitiesStatusesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities-statuses/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const opportunitiesStatusesUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesStatusesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    OpportunitiesStatusesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities-statuses/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const opportunitiesStatusesListList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<OpportunitiesStatusesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    OpportunitiesStatusesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/opportunities-statuses/list',
    ...options
  })
}

export const opportunitiesContactsList = <ThrowOnError extends boolean = false>(
  options: Options<OpportunitiesContactsListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    OpportunitiesContactsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/opportunities/{opportunity_id}/contacts',
    ...options
  })
}

export const opportunitiesContractsList = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesContractsListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    OpportunitiesContractsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/opportunities/{opportunity_id}/contracts',
    ...options
  })
}

export const opportunitiesDocumentsList = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesDocumentsListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    OpportunitiesDocumentsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/opportunities/{opportunity_id}/documents',
    ...options
  })
}

export const opportunitiesLogsList = <ThrowOnError extends boolean = false>(
  options: Options<OpportunitiesLogsListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    OpportunitiesLogsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/opportunities/{opportunity_id}/logs',
    ...options
  })
}

export const opportunitiesTasksList = <ThrowOnError extends boolean = false>(
  options: Options<OpportunitiesTasksListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    OpportunitiesTasksListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/opportunities/{opportunity_id}/tasks',
    ...options
  })
}

export const opportunitiesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<OpportunitiesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    OpportunitiesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities/{id}',
    ...options
  })
}

export const opportunitiesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<OpportunitiesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    OpportunitiesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities/{id}',
    ...options
  })
}

export const opportunitiesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    OpportunitiesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const opportunitiesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<OpportunitiesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    OpportunitiesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const opportunitiesConvertToClientCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesConvertToClientCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    OpportunitiesConvertToClientCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities/{id}/convert-to-client',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const opportunitiesDuplicateCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesDuplicateCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    OpportunitiesDuplicateCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities/{id}/duplicate',
    ...options
  })
}

export const opportunitiesMergePartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesMergePartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    OpportunitiesMergePartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities/{id}/merge',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const opportunitiesPipelineList = <ThrowOnError extends boolean = false>(
  options?: Options<OpportunitiesPipelineListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    OpportunitiesPipelineListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/opportunities/pipeline',
    ...options
  })
}

export const opportunitiesPipelinesList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<OpportunitiesPipelinesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    OpportunitiesPipelinesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/opportunities/pipelines',
    ...options
  })
}

export const opportunitiesPipelinesCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesPipelinesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    OpportunitiesPipelinesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities/pipelines',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const opportunitiesPipelinesStatusesList = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesPipelinesStatusesListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    OpportunitiesPipelinesStatusesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/opportunities/pipelines/{pipeline_id}/statuses',
    ...options
  })
}

export const opportunitiesPipelinesStatusesCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesPipelinesStatusesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    OpportunitiesPipelinesStatusesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities/pipelines/{pipeline_id}/statuses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const opportunitiesPipelinesStatusesDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesPipelinesStatusesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    OpportunitiesPipelinesStatusesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities/pipelines/{pipeline_id}/statuses/{id}',
    ...options
  })
}

export const opportunitiesPipelinesStatusesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesPipelinesStatusesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    OpportunitiesPipelinesStatusesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities/pipelines/{pipeline_id}/statuses/{id}',
    ...options
  })
}

export const opportunitiesPipelinesStatusesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    OpportunitiesPipelinesStatusesPartialUpdateData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).patch<
    OpportunitiesPipelinesStatusesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities/pipelines/{pipeline_id}/statuses/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const opportunitiesPipelinesStatusesUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesPipelinesStatusesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    OpportunitiesPipelinesStatusesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities/pipelines/{pipeline_id}/statuses/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const opportunitiesPipelinesStatusesListList = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesPipelinesStatusesListListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    OpportunitiesPipelinesStatusesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/opportunities/pipelines/{pipeline_id}/statuses/list',
    ...options
  })
}

export const opportunitiesPipelinesDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesPipelinesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    OpportunitiesPipelinesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities/pipelines/{id}',
    ...options
  })
}

export const opportunitiesPipelinesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesPipelinesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    OpportunitiesPipelinesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities/pipelines/{id}',
    ...options
  })
}

export const opportunitiesPipelinesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesPipelinesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    OpportunitiesPipelinesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities/pipelines/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const opportunitiesPipelinesUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesPipelinesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    OpportunitiesPipelinesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities/pipelines/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const opportunitiesPipelinesListList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<OpportunitiesPipelinesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    OpportunitiesPipelinesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/opportunities/pipelines/list',
    ...options
  })
}

export const opportunitiesProductsList = <ThrowOnError extends boolean = false>(
  options?: Options<OpportunitiesProductsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    OpportunitiesProductsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/opportunities/products',
    ...options
  })
}

export const opportunitiesProductsCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesProductsCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    OpportunitiesProductsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities/products',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const opportunitiesProductsDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesProductsDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    OpportunitiesProductsDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities/products/{id}',
    ...options
  })
}

export const opportunitiesProductsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesProductsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    OpportunitiesProductsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities/products/{id}',
    ...options
  })
}

export const opportunitiesProductsPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesProductsPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    OpportunitiesProductsPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities/products/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const opportunitiesProductsUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesProductsUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    OpportunitiesProductsUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities/products/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const opportunitiesProductsBulkCreateCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<OpportunitiesProductsBulkCreateCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    OpportunitiesProductsBulkCreateCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities/products/bulk-create',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const opportunitiesProductsBulkUpdatePartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    OpportunitiesProductsBulkUpdatePartialUpdateData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).patch<
    OpportunitiesProductsBulkUpdatePartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/opportunities/products/bulk-update',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const presetTasksList = <ThrowOnError extends boolean = false>(
  options?: Options<PresetTasksListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    PresetTasksListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/preset-tasks',
    ...options
  })
}

export const presetTasksCreate = <ThrowOnError extends boolean = false>(
  options: Options<PresetTasksCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PresetTasksCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/preset-tasks',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const presetTasksDestroy = <ThrowOnError extends boolean = false>(
  options: Options<PresetTasksDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    PresetTasksDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/preset-tasks/{id}',
    ...options
  })
}

export const presetTasksRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<PresetTasksRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    PresetTasksRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/preset-tasks/{id}',
    ...options
  })
}

export const presetTasksPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<PresetTasksPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    PresetTasksPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/preset-tasks/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const presetTasksUpdate = <ThrowOnError extends boolean = false>(
  options: Options<PresetTasksUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    PresetTasksUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/preset-tasks/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const productsList = <ThrowOnError extends boolean = false>(
  options?: Options<ProductsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ProductsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/products',
    ...options
  })
}

export const productsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProductsCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ProductsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/products',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const productsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ProductsDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    ProductsDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/products/{id}',
    ...options
  })
}

export const productsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ProductsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ProductsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/products/{id}',
    ...options
  })
}

export const productsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ProductsPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    ProductsPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/products/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const productsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ProductsUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    ProductsUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/products/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const productsCategoriesList = <ThrowOnError extends boolean = false>(
  options?: Options<ProductsCategoriesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ProductsCategoriesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/products/categories',
    ...options
  })
}

export const productsCategoriesCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProductsCategoriesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ProductsCategoriesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/products/categories',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const productsCategoriesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ProductsCategoriesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    ProductsCategoriesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/products/categories/{id}',
    ...options
  })
}

export const productsCategoriesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ProductsCategoriesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ProductsCategoriesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/products/categories/{id}',
    ...options
  })
}

export const productsCategoriesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ProductsCategoriesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    ProductsCategoriesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/products/categories/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const productsCategoriesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ProductsCategoriesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    ProductsCategoriesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/products/categories/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const productsCategoriesListList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ProductsCategoriesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ProductsCategoriesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/products/categories/list',
    ...options
  })
}

export const productsListList = <ThrowOnError extends boolean = false>(
  options?: Options<ProductsListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ProductsListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/products/list',
    ...options
  })
}

export const productsUnitsOfMeasureList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ProductsUnitsOfMeasureListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ProductsUnitsOfMeasureListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/products/units-of-measure',
    ...options
  })
}

export const productsUnitsOfMeasureCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ProductsUnitsOfMeasureCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ProductsUnitsOfMeasureCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/products/units-of-measure',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const productsUnitsOfMeasureDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<ProductsUnitsOfMeasureDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    ProductsUnitsOfMeasureDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/products/units-of-measure/{id}',
    ...options
  })
}

export const productsUnitsOfMeasureRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ProductsUnitsOfMeasureRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ProductsUnitsOfMeasureRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/products/units-of-measure/{id}',
    ...options
  })
}

export const productsUnitsOfMeasurePartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ProductsUnitsOfMeasurePartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    ProductsUnitsOfMeasurePartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/products/units-of-measure/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const productsUnitsOfMeasureUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ProductsUnitsOfMeasureUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    ProductsUnitsOfMeasureUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/products/units-of-measure/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const productsUnitsOfMeasureListList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ProductsUnitsOfMeasureListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ProductsUnitsOfMeasureListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/products/units-of-measure/list',
    ...options
  })
}

export const reasonsList = <ThrowOnError extends boolean = false>(
  options?: Options<ReasonsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ReasonsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/reasons',
    ...options
  })
}

export const reasonsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ReasonsCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ReasonsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reasons',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const reasonsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ReasonsDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    ReasonsDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reasons/{id}',
    ...options
  })
}

export const reasonsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ReasonsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ReasonsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reasons/{id}',
    ...options
  })
}

export const reasonsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ReasonsPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    ReasonsPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reasons/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const reasonsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ReasonsUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    ReasonsUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reasons/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const reasonsListList = <ThrowOnError extends boolean = false>(
  options?: Options<ReasonsListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ReasonsListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/reasons/list',
    ...options
  })
}

export const regionsList = <ThrowOnError extends boolean = false>(
  options?: Options<RegionsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    RegionsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/regions',
    ...options
  })
}

export const regionsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<RegionsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    RegionsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/regions/{id}',
    ...options
  })
}

export const regionsListList = <ThrowOnError extends boolean = false>(
  options?: Options<RegionsListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    RegionsListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/regions/list',
    ...options
  })
}

export const reportsList = <ThrowOnError extends boolean = false>(
  options?: Options<ReportsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ReportsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports',
    ...options
  })
}

export const reportsCreate = <ThrowOnError extends boolean = false>(
  options?: Options<ReportsCreateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    ReportsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const reportsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ReportsDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    ReportsDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/{id}',
    ...options
  })
}

export const reportsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ReportsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ReportsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/{id}',
    ...options
  })
}

export const reportsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ReportsPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    ReportsPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const reportsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ReportsUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    ReportsUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const reportsChartRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ReportsChartRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ReportsChartRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/{id}/chart',
    ...options
  })
}

export const reportsDuplicateCreate = <ThrowOnError extends boolean = false>(
  options: Options<ReportsDuplicateCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ReportsDuplicateCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/{id}/duplicate',
    ...options
  })
}

export const reportsModelFieldsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ReportsModelFieldsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ReportsModelFieldsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/{id}/model-fields',
    ...options
  })
}

export const reportsTableRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ReportsTableRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ReportsTableRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/{id}/table',
    ...options
  })
}

export const reportsAggTypesRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<ReportsAggTypesRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ReportsAggTypesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/agg-types',
    ...options
  })
}

export const reportsCallsReportsList = <ThrowOnError extends boolean = false>(
  options?: Options<ReportsCallsReportsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ReportsCallsReportsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/reports/calls-reports',
    ...options
  })
}

export const reportsCountryWeightDiagramRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ReportsCountryWeightDiagramRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ReportsCountryWeightDiagramRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/country-weight-diagram',
    ...options
  })
}

export const reportsDemoChartList = <ThrowOnError extends boolean = false>(
  options?: Options<ReportsDemoChartListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ReportsDemoChartListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/demo-chart',
    ...options
  })
}

export const reportsExportsList = <ThrowOnError extends boolean = false>(
  options?: Options<ReportsExportsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ReportsExportsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/reports/exports',
    ...options
  })
}

export const reportsExportsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ReportsExportsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ReportsExportsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/exports/{id}',
    ...options
  })
}

export const reportsLeadChartList = <ThrowOnError extends boolean = false>(
  options?: Options<ReportsLeadChartListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ReportsLeadChartListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/lead-chart',
    ...options
  })
}

export const reportsOfflineReportsList = <ThrowOnError extends boolean = false>(
  options?: Options<ReportsOfflineReportsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ReportsOfflineReportsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/reports/offline-reports',
    ...options
  })
}

export const reportsOnlineReportsList = <ThrowOnError extends boolean = false>(
  options?: Options<ReportsOnlineReportsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ReportsOnlineReportsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/reports/online-reports',
    ...options
  })
}

export const reportsPhoneCallsChartList = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ReportsPhoneCallsChartListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ReportsPhoneCallsChartListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/phone-calls-chart',
    ...options
  })
}

export const reportsPreviewChartCreate = <ThrowOnError extends boolean = false>(
  options?: Options<ReportsPreviewChartCreateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    ReportsPreviewChartCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/preview-chart',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const reportsPreviewTableCreate = <ThrowOnError extends boolean = false>(
  options?: Options<ReportsPreviewTableCreateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    ReportsPreviewTableCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/preview-table',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const reportsReasonWeightDiagramRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ReportsReasonWeightDiagramRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ReportsReasonWeightDiagramRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/reason-weight-diagram',
    ...options
  })
}

export const reportsSalesFunnelList = <ThrowOnError extends boolean = false>(
  options?: Options<ReportsSalesFunnelListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ReportsSalesFunnelListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/reports/sales-funnel',
    ...options
  })
}

export const reportsScoreWeightDiagramRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ReportsScoreWeightDiagramRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ReportsScoreWeightDiagramRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/score-weight-diagram',
    ...options
  })
}

export const reportsSourcePageWeightDiagramRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ReportsSourcePageWeightDiagramRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ReportsSourcePageWeightDiagramRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/source-page-weight-diagram',
    ...options
  })
}

export const reportsSourceWebsiteWeightDiagramRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ReportsSourceWebsiteWeightDiagramRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ReportsSourceWebsiteWeightDiagramRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/source-website-weight-diagram',
    ...options
  })
}

export const reportsSourceWeightDiagramRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ReportsSourceWeightDiagramRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ReportsSourceWeightDiagramRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/source-weight-diagram',
    ...options
  })
}

export const reportsStatusWeightDiagramRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ReportsStatusWeightDiagramRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ReportsStatusWeightDiagramRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/status-weight-diagram',
    ...options
  })
}

export const reportsTopProductsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ReportsTopProductsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ReportsTopProductsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/top-products',
    ...options
  })
}

export const reportsTopProductsCategoryDistributionRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    ReportsTopProductsCategoryDistributionRetrieveData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ReportsTopProductsCategoryDistributionRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/top-products/category-distribution',
    ...options
  })
}

export const reportsTopProductsCategoryDistributionExportCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    ReportsTopProductsCategoryDistributionExportCreateData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    ReportsTopProductsCategoryDistributionExportCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/top-products/category-distribution/export',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const reportsTopProductsExportCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ReportsTopProductsExportCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ReportsTopProductsExportCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/top-products/export',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const reportsTypesRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<ReportsTypesRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ReportsTypesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/reports/types',
    ...options
  })
}

/**
 * OpenApi3 schema for this API. Format can be selected via content negotiation.
 *
 * - YAML: application/vnd.oai.openapi
 * - JSON: application/vnd.oai.openapi+json
 */
export const schemaRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<SchemaRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    SchemaRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'blob',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/schema',
    ...options
  })
}

export const searchList = <ThrowOnError extends boolean = false>(
  options?: Options<SearchListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    SearchListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/search',
    ...options
  })
}

export const searchDynamicList = <ThrowOnError extends boolean = false>(
  options?: Options<SearchDynamicListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    SearchDynamicListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/search/dynamic',
    ...options
  })
}

export const searchDynamicExportRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<SearchDynamicExportRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    SearchDynamicExportRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'blob',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/search/dynamic/export',
    ...options
  })
}

export const searchDynamicModelFieldsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<SearchDynamicModelFieldsRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    SearchDynamicModelFieldsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/search/dynamic/model-fields',
    ...options
  })
}

export const searchDynamicModelsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<SearchDynamicModelsRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    SearchDynamicModelsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/search/dynamic/models',
    ...options
  })
}

export const seniorPositionsList = <ThrowOnError extends boolean = false>(
  options?: Options<SeniorPositionsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    SeniorPositionsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/senior-positions',
    ...options
  })
}

export const seniorPositionsCreate = <ThrowOnError extends boolean = false>(
  options: Options<SeniorPositionsCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    SeniorPositionsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/senior-positions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const seniorPositionsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<SeniorPositionsDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    SeniorPositionsDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/senior-positions/{id}',
    ...options
  })
}

export const seniorPositionsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<SeniorPositionsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    SeniorPositionsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/senior-positions/{id}',
    ...options
  })
}

export const seniorPositionsPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<SeniorPositionsPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    SeniorPositionsPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/senior-positions/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const seniorPositionsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<SeniorPositionsUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    SeniorPositionsUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/senior-positions/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const seniorPositionsJobPositionsList = <
  ThrowOnError extends boolean = false
>(
  options: Options<SeniorPositionsJobPositionsListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    SeniorPositionsJobPositionsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/senior-positions/{senior_position_id}/job-positions',
    ...options
  })
}

export const seniorPositionsJobPositionsCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<SeniorPositionsJobPositionsCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    SeniorPositionsJobPositionsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/senior-positions/{senior_position_id}/job-positions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const seniorPositionsJobPositionsDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<SeniorPositionsJobPositionsDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    SeniorPositionsJobPositionsDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/senior-positions/{senior_position_id}/job-positions/{id}',
    ...options
  })
}

export const seniorPositionsJobPositionsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<SeniorPositionsJobPositionsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    SeniorPositionsJobPositionsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/senior-positions/{senior_position_id}/job-positions/{id}',
    ...options
  })
}

export const seniorPositionsJobPositionsPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<SeniorPositionsJobPositionsPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    SeniorPositionsJobPositionsPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/senior-positions/{senior_position_id}/job-positions/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const seniorPositionsJobPositionsUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<SeniorPositionsJobPositionsUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    SeniorPositionsJobPositionsUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/senior-positions/{senior_position_id}/job-positions/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const seniorPositionsJobPositionsListList = <
  ThrowOnError extends boolean = false
>(
  options: Options<SeniorPositionsJobPositionsListListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    SeniorPositionsJobPositionsListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/senior-positions/{senior_position_id}/job-positions/list',
    ...options
  })
}

export const seniorPositionsListList = <ThrowOnError extends boolean = false>(
  options?: Options<SeniorPositionsListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    SeniorPositionsListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/senior-positions/list',
    ...options
  })
}

export const sequencesList = <ThrowOnError extends boolean = false>(
  options?: Options<SequencesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    SequencesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/sequences',
    ...options
  })
}

export const sequencesCreate = <ThrowOnError extends boolean = false>(
  options?: Options<SequencesCreateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    SequencesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/sequences',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const sequencesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<SequencesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    SequencesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/sequences/{id}',
    ...options
  })
}

export const sequencesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<SequencesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    SequencesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/sequences/{id}',
    ...options
  })
}

export const sequencesPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<SequencesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    SequencesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/sequences/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const sequencesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<SequencesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    SequencesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/sequences/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const sequencesAddLeadsCreate = <ThrowOnError extends boolean = false>(
  options: Options<SequencesAddLeadsCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    SequencesAddLeadsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/sequences/{id}/add-leads',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const sequencesDuplicateRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<SequencesDuplicateRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    SequencesDuplicateRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/sequences/{id}/duplicate',
    ...options
  })
}

export const sequencesLeadsList = <ThrowOnError extends boolean = false>(
  options: Options<SequencesLeadsListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    SequencesLeadsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/sequences/{sequence_id}/leads',
    ...options
  })
}

export const sequencesStepsList = <ThrowOnError extends boolean = false>(
  options: Options<SequencesStepsListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    SequencesStepsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/sequences/{sequence_id}/steps',
    ...options
  })
}

export const sequencesStepsCreate = <ThrowOnError extends boolean = false>(
  options: Options<SequencesStepsCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    SequencesStepsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/sequences/{sequence_id}/steps',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const sequencesStepsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<SequencesStepsDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    SequencesStepsDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/sequences/{sequence_id}/steps/{id}',
    ...options
  })
}

export const sequencesStepsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<SequencesStepsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    SequencesStepsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/sequences/{sequence_id}/steps/{id}',
    ...options
  })
}

export const sequencesStepsPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<SequencesStepsPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    SequencesStepsPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/sequences/{sequence_id}/steps/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const sequencesStepsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<SequencesStepsUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    SequencesStepsUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/sequences/{sequence_id}/steps/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const sequencesStepsListList = <ThrowOnError extends boolean = false>(
  options: Options<SequencesStepsListListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    SequencesStepsListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/sequences/{sequence_id}/steps/list',
    ...options
  })
}

export const sequencesListList = <ThrowOnError extends boolean = false>(
  options?: Options<SequencesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    SequencesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/sequences/list',
    ...options
  })
}

export const settingsRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<SettingsRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    SettingsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/settings',
    ...options
  })
}

export const settingsCreate = <ThrowOnError extends boolean = false>(
  options?: Options<SettingsCreateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    SettingsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/settings',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const sourcesList = <ThrowOnError extends boolean = false>(
  options?: Options<SourcesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    SourcesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/sources',
    ...options
  })
}

export const sourcesCreate = <ThrowOnError extends boolean = false>(
  options: Options<SourcesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    SourcesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/sources',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const sourcesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<SourcesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    SourcesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/sources/{id}',
    ...options
  })
}

export const sourcesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<SourcesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    SourcesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/sources/{id}',
    ...options
  })
}

export const sourcesPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<SourcesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    SourcesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/sources/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const sourcesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<SourcesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    SourcesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/sources/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const sourcesListList = <ThrowOnError extends boolean = false>(
  options?: Options<SourcesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    SourcesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/sources/list',
    ...options
  })
}

export const tagsList = <ThrowOnError extends boolean = false>(
  options?: Options<TagsListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    TagsListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/tags',
    ...options
  })
}

export const tagsCreate = <ThrowOnError extends boolean = false>(
  options: Options<TagsCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    TagsCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/tags',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const tagsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<TagsDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    TagsDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/tags/{id}',
    ...options
  })
}

export const tagsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<TagsRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    TagsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/tags/{id}',
    ...options
  })
}

export const tagsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TagsPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    TagsPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/tags/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const tagsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TagsUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    TagsUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/tags/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const tagsColorsRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<TagsColorsRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    TagsColorsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/tags/colors',
    ...options
  })
}

export const tagsListList = <ThrowOnError extends boolean = false>(
  options?: Options<TagsListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    TagsListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/tags/list',
    ...options
  })
}

export const taskStatusesList = <ThrowOnError extends boolean = false>(
  options?: Options<TaskStatusesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    TaskStatusesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/task-statuses',
    ...options
  })
}

export const taskStatusesCreate = <ThrowOnError extends boolean = false>(
  options: Options<TaskStatusesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    TaskStatusesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/task-statuses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const taskStatusesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<TaskStatusesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    TaskStatusesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/task-statuses/{id}',
    ...options
  })
}

export const taskStatusesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<TaskStatusesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    TaskStatusesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/task-statuses/{id}',
    ...options
  })
}

export const taskStatusesPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TaskStatusesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    TaskStatusesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/task-statuses/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const taskStatusesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TaskStatusesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    TaskStatusesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/task-statuses/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const taskStatusesListList = <ThrowOnError extends boolean = false>(
  options?: Options<TaskStatusesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    TaskStatusesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/task-statuses/list',
    ...options
  })
}

export const taskTypesList = <ThrowOnError extends boolean = false>(
  options?: Options<TaskTypesListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    TaskTypesListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/task-types',
    ...options
  })
}

export const taskTypesCreate = <ThrowOnError extends boolean = false>(
  options: Options<TaskTypesCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    TaskTypesCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/task-types',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const taskTypesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<TaskTypesDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    TaskTypesDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/task-types/{id}',
    ...options
  })
}

export const taskTypesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<TaskTypesRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    TaskTypesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/task-types/{id}',
    ...options
  })
}

export const taskTypesPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TaskTypesPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    TaskTypesPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/task-types/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const taskTypesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TaskTypesUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    TaskTypesUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/task-types/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const taskTypesAllRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<TaskTypesAllRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    TaskTypesAllRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/task-types/all',
    ...options
  })
}

export const taskTypesGenericList = <ThrowOnError extends boolean = false>(
  options?: Options<TaskTypesGenericListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    TaskTypesGenericListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/task-types/generic',
    ...options
  })
}

export const taskTypesListList = <ThrowOnError extends boolean = false>(
  options?: Options<TaskTypesListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    TaskTypesListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/task-types/list',
    ...options
  })
}

export const taskTypesSystemList = <ThrowOnError extends boolean = false>(
  options?: Options<TaskTypesSystemListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    TaskTypesSystemListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/task-types/system',
    ...options
  })
}

export const tasksList = <ThrowOnError extends boolean = false>(
  options?: Options<TasksListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    TasksListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/tasks',
    ...options
  })
}

export const tasksCreate = <ThrowOnError extends boolean = false>(
  options: Options<TasksCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    TasksCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/tasks',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const tasksDestroy = <ThrowOnError extends boolean = false>(
  options: Options<TasksDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    TasksDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/tasks/{id}',
    ...options
  })
}

export const tasksRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<TasksRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    TasksRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/tasks/{id}',
    ...options
  })
}

export const tasksPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TasksPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    TasksPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/tasks/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const tasksUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TasksUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    TasksUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/tasks/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const tasksCompleteCreate = <ThrowOnError extends boolean = false>(
  options: Options<TasksCompleteCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    TasksCompleteCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/tasks/{id}/complete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const tasksKanbanList = <ThrowOnError extends boolean = false>(
  options?: Options<TasksKanbanListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    TasksKanbanListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/tasks/kanban',
    ...options
  })
}

export const usersList = <ThrowOnError extends boolean = false>(
  options?: Options<UsersListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    UsersListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/users',
    ...options
  })
}

export const usersPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<UsersPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    UsersPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/users/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const usersUpdate = <ThrowOnError extends boolean = false>(
  options: Options<UsersUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    UsersUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/users/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const usersAllList = <ThrowOnError extends boolean = false>(
  options?: Options<UsersAllListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    UsersAllListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/users/all',
    ...options
  })
}

export const usersAllowedModulesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<UsersAllowedModulesRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    UsersAllowedModulesRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/users/allowed-modules',
    ...options
  })
}

export const usersListList = <ThrowOnError extends boolean = false>(
  options?: Options<UsersListListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    UsersListListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: 'form'
      }
    },
    url: '/users/list',
    ...options
  })
}

export const usersProfileRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<UsersProfileRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    UsersProfileRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/users/profile',
    ...options
  })
}

export const voipConfigurationList = <ThrowOnError extends boolean = false>(
  options?: Options<VoipConfigurationListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    VoipConfigurationListResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/voip/configuration',
    ...options
  })
}

export const voipConfigurationCreate = <ThrowOnError extends boolean = false>(
  options: Options<VoipConfigurationCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    VoipConfigurationCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/voip/configuration',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const voipConfigurationDestroy = <ThrowOnError extends boolean = false>(
  options: Options<VoipConfigurationDestroyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    VoipConfigurationDestroyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/voip/configuration/{id}',
    ...options
  })
}

export const voipConfigurationRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<VoipConfigurationRetrieveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    VoipConfigurationRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/voip/configuration/{id}',
    ...options
  })
}

export const voipConfigurationPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<VoipConfigurationPartialUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    VoipConfigurationPartialUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/voip/configuration/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const voipConfigurationUpdate = <ThrowOnError extends boolean = false>(
  options: Options<VoipConfigurationUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    VoipConfigurationUpdateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/voip/configuration/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const voipConfigurationStatusRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<VoipConfigurationStatusRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    VoipConfigurationStatusRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/voip/configuration/status',
    ...options
  })
}

export const webhookLeadCreate = <ThrowOnError extends boolean = false>(
  options?: Options<WebhookLeadCreateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    WebhookLeadCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/webhook/lead',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

/**
 * Handle MINIO put and delete events webhook
 * Expected payload format:
 * {
 * "EventName": "s3:ObjectCreated:Put" | "s3:ObjectRemoved:Delete",
 * "Key": "object_name",
 * "Records": [{
 * "s3": {
 * "bucket": {
 * "name": "bucket-name"
 * },
 * "object": {
 * "key": "object_name",
 * "size": 1234,
 * "contentType": "application/pdf"
 * }
 * },
 * "source": {
 * "host": "minio-host",
 * "port": "9000"
 * }
 * }]
 * }
 */
export const webhookMinioCreate = <ThrowOnError extends boolean = false>(
  options?: Options<WebhookMinioCreateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    WebhookMinioCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/webhook/minio',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const webhookTaskCreate = <ThrowOnError extends boolean = false>(
  options?: Options<WebhookTaskCreateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    WebhookTaskCreateResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/webhook/task',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const webhookVoipCreate = <ThrowOnError extends boolean = false>(
  options?: Options<WebhookVoipCreateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: '/webhook/voip',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const webhookWhatsappRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<WebhookWhatsappRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>(
    {
      url: '/webhook/whatsapp',
      ...options
    }
  )
}

export const webhookWhatsappCreate = <ThrowOnError extends boolean = false>(
  options?: Options<WebhookWhatsappCreateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    unknown,
    unknown,
    ThrowOnError
  >({
    url: '/webhook/whatsapp',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  })
}

export const widgetsRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<WidgetsRetrieveData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    WidgetsRetrieveResponse,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    security: [
      {
        name: 'Authorization',
        type: 'apiKey'
      },
      {
        name: 'Saas-app-token',
        type: 'apiKey'
      }
    ],
    url: '/widgets',
    ...options
  })
}
